

export const defaultCourseData = {
  python: {
    name: "Python",
    modules: [
      {
        moduleTitle: "Python Introduction",
        topics: [
          { title: "Introduction to Python Programming" },
          { title: "Installation of Python & Associated packages"},
          { title: "Graphical User Interface", videoLink: "https://example.com/video3" },
          { title: "Installation of Anaconda Python", videoLink: "https://example.com/video4" },
          { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Data Types",
        topics: [
          { title: "Python Introduction", videoLink: "https://example.com/video6" },
          { title: "Integer", videoLink: "https://example.com/video7" },
          { title: "Float", videoLink: "https://example.com/video8" },
          { title: "String", videoLink: "https://example.com/video9" },
          { title: "Boolean", videoLink: "https://example.com/video10" },
          { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Operators in Python",
        topics: [
          { title: "Arithmetic operators", videoLink: "https://example.com/video12" },
          { title: "Relational operators", videoLink: "https://example.com/video13" },
          { title: "Logical operators", videoLink: "https://example.com/video14" },
          { title: "Assignment operators", videoLink: "https://example.com/video15" },
          { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          { title: "Membership operators", videoLink: "https://example.com/video17" },
          { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Data Structures",
        topics: [
          { title: "1D vs 2D data structures", videoLink: "https://example.com/video19" },
          { title: "Lists", videoLink: "https://example.com/video20" },
          { title: "Tuple", videoLink: "https://example.com/video21" },
          { title: "Sets", videoLink: "https://example.com/video22" },
          { title: "Dictionary", videoLink: "https://example.com/video23" },
          { title: "String Representation", videoLink: "https://example.com/video24" },
          { title: "Arrays", videoLink: "https://example.com/video25" },
          { title: "Matrix", videoLink: "https://example.com/video26" },
          { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "Conditional Statements",
        topics: [
          { title: "if statement", videoLink: "https://example.com/video28" },
          { title: "if - else statement", videoLink: "https://example.com/video29" },
          { title: "if - elif statement", videoLink: "https://example.com/video30" },
          { title: "Nested if-else", videoLink: "https://example.com/video31" },
          { title: "Case", videoLink: "https://example.com/video32" }
        ]
      },
      {
        moduleTitle: "Loops",
        topics: [
          { title: "Finite vs Infinite loops", videoLink: "https://example.com/video33" },
          { title: "For loop", videoLink: "https://example.com/video34" },
          { title: "while loop", videoLink: "https://example.com/video35" },
          { title: "Nested loop", videoLink: "https://example.com/video36" },
          { title: "Control statement", videoLink: "https://example.com/video37" },
          { title: "pass", videoLink: "https://example.com/video38" },
          { title: "continue", videoLink: "https://example.com/video39" },
          { title: "break", videoLink: "https://example.com/video40" }
        ]
      },
      {
        moduleTitle: "Functions",
        topics: [
          { title: "Purpose of a function", videoLink: "https://example.com/video41" },
          { title: "Defining a function", videoLink: "https://example.com/video42" },
          { title: "Calling a function", videoLink: "https://example.com/video43" },
          { title: "Function parameter passing", videoLink: "https://example.com/video44" },
          { title: "Formal arguments", videoLink: "https://example.com/video45" },
          { title: "Actual arguments", videoLink: "https://example.com/video46" },
          { title: "Positional arguments", videoLink: "https://example.com/video47" },
          { title: "Keyword arguments", videoLink: "https://example.com/video48" },
          { title: "Variable arguments", videoLink: "https://example.com/video49" },
          { title: "Variable keyword arguments", videoLink: "https://example.com/video50" },
          { title: "Use-Case *args, **kwargs", videoLink: "https://example.com/video51" },
          { title: "Function call stack", videoLink: "https://example.com/video52" },
          { title: "Locals()", videoLink: "https://example.com/video53" },
          { title: "Globals()", videoLink: "https://example.com/video54" },
          { title: "Lambda functions", videoLink: "https://example.com/video55" },
          { title: "Build-in Functions", videoLink: "https://example.com/video56" },
          { title: "Importing functions from another file", videoLink: "https://example.com/video57" }
        ]
      },
      {
        moduleTitle: "Comprehensions",
        topics: [
          { title: "List comprehension", videoLink: "https://example.com/video58" },
          { title: "Dictionary comprehension", videoLink: "https://example.com/video59" },
          { title: "Enumerate", videoLink: "https://example.com/video60" },
          { title: "Zip and unzip", videoLink: "https://example.com/video61" },
          { title: "Loop vs Comprehension vs Lambda", videoLink: "https://example.com/video62" }
        ]
      },
      {
        moduleTitle: "File Handling",
        topics: [
          { title: "open() function", videoLink: "https://example.com/video63" },
          { title: "Modes of open function", videoLink: "https://example.com/video64" }
        ]
      },
      {
        moduleTitle: "Exception Handling",
        topics: [
          { title: "Built-in Exceptions", videoLink: "https://example.com/video65" },
          { title: "Try and Exception blocks", videoLink: "https://example.com/video66" },
          { title: "User defined Exceptions", videoLink: "https://example.com/video67" },
          { title: "Handling Missing Keys", videoLink: "https://example.com/video68" }
        ]
      },
      {
        moduleTitle: "Python Package for Data Analysis",
        topics: [
          { title: "Numpy – Arrays, Memory, Matrices, Broadcasting, Masked Arrays", videoLink: "https://example.com/video69" },
          { title: "Pandas – Series, Dataframes", videoLink: "https://example.com/video70" },
          { title: "Matplotlib", videoLink: "https://example.com/video71" },
          { title: "Seaborn", videoLink: "https://example.com/video72" }
        ]
      },
      {
        moduleTitle: "Data Visualization",
        topics: [
          { title: "Line Chart", videoLink: "https://example.com/video73" },
          { title: "Bar Chart", videoLink: "https://example.com/video74" },
          { title: "Histogram", videoLink: "https://example.com/video75" },
          { title: "Pie Charts", videoLink: "https://example.com/video76" },
          { title: "Box Plots", videoLink: "https://example.com/video77" },
          { title: "Scatter Plots", videoLink: "https://example.com/video78" },
          { title: "Figures & Subplots", videoLink: "https://example.com/video79" },
          { title: "Additional Visualization Packages", videoLink: "https://example.com/video80" }
        ]
      },
      {
        moduleTitle: "Regular Expression",
        topics: [
          { title: "re() package", videoLink: "https://example.com/video81" },
          { title: "sub", videoLink: "https://example.com/video82" },
          { title: "findall", videoLink: "https://example.com/video83" },
          { title: "split", videoLink: "https://example.com/video84" }
        ]
      },
      {
        moduleTitle: "Data Collection and Data Wrangling",
        topics: [
          { title: "Typecasting", videoLink: "https://example.com/video85" },
          { title: "Handling Duplicates & Categorical Data", videoLink: "https://example.com/video86" },
          { title: "Transformations", videoLink: "https://example.com/video87" },
          { title: "Imputation", videoLink: "https://example.com/video88" }
        ]
      }
    ]
  },
  "SQL for Data Engineering": {
    name: "SQL for Data Engineering",
    modules: [
      {
        moduleTitle: "SQL Commands Fundamentals",
        topics: [
          { title: "ACID properties" },
          { title: "DDL"},
          { title: "DCL", videoLink: "https://example.com/video3" },
          { title: "DML", videoLink: "https://example.com/video4" },
          { title: "TCL", videoLink: "https://example.com/video5" },
          { title: "DQL", videoLink: "https://example.com/video5" }
        ]
      },
      
      
      {
        moduleTitle: "SQL Commands Handson",
        topics: [
          { title: " SELECT", videoLink: "https://example.com/video6" },
          { title: "WHERE", videoLink: "https://example.com/video7" },
          { title: "ORDER BY", videoLink: "https://example.com/video8" },
          { title: "GROUP BY", videoLink: "https://example.com/video9" },
          { title: "Boolean", videoLink: "https://example.com/video10" },
           { title: "JOINs", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Advanced SQL",
        topics: [
          { title: "Subqueries", videoLink: "https://example.com/video12" },
          { title: "CTEs", videoLink: "https://example.com/video13" },
          { title: "Window functions", videoLink: "https://example.com/video14" },
          { title: "Assignment operators", videoLink: "https://example.com/video15" },
          { title: "Pivoting", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Hands-on",
        topics: [
          { title: "Use MySQL/PostgreSQL with sample datasets", videoLink: "https://example.com/video19" },
          // { title: "Lists", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "Libraries for Data Engineering",
        topics: [
          { title: "pandas", videoLink: "https://example.com/video28" },
          { title: "numpy", videoLink: "https://example.com/video29" },
          { title: "os", videoLink: "https://example.com/video30" },
          { title: "glob", videoLink: "https://example.com/video31" },
          { title: "logging", videoLink: "https://example.com/video32" }
        ]
      },
      {
        moduleTitle: "Automation",
        topics: [
          { title: "logging", videoLink: "https://example.com/video33" },
          { title: "error handling", videoLink: "https://example.com/video34" },
          // { title: "while loop", videoLink: "https://example.com/video35" },
          // { title: "Nested loop", videoLink: "https://example.com/video36" },
          // { title: "Control statement", videoLink: "https://example.com/video37" },
          // { title: "pass", videoLink: "https://example.com/video38" },
          // { title: "continue", videoLink: "https://example.com/video39" },
          // { title: "break", videoLink: "https://example.com/video40" }
        ]
      },
    ],

  },
    "Exploratory Data Analysis (EDA)"  : {
    name: "Exploratory Data Analysis (EDA)",
    modules: [
      {
        moduleTitle: "Understanding the Data",
        topics: [
          { title: "Types of data" },
          { title: "schema"},
          { title: "metadata", videoLink: "https://example.com/video3" },
          // { title: "Installation of Anaconda Python", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Using pandas for EDA",
        topics: [
          { title: "Summary statistics", videoLink: "https://example.com/video6" },
          { title: "missing values", videoLink: "https://example.com/video7" },
          { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Data Cleaning Techniques",
        topics: [
          { title: "Null handling", videoLink: "https://example.com/video12" },
          { title: "outlier treatment", videoLink: "https://example.com/video13" },
           { title: "deduplication", videoLink: "https://example.com/video14" },
          // { title: "Assignment operators", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Visualization",
        topics: [
          { title: "matplotlib" , videoLink: "https://example.com/video19" },
          { title: "seaborn for trend analysis", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "Case Study",
        topics: [
          { title: "Analyze sales or user behavior dataset", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
    ],
    
    
  },
   "Data Engineering with Azure"  : {
    name: "Data Engineering with Azure",
    modules: [
      {
        moduleTitle: "Azure Data Lake Gen2",
        topics: [
          // { title: "Types of data" },
          // { title: "schema"},
          // { title: "metadata", videoLink: "https://example.com/video3" },
          // { title: "Installation of Anaconda Python", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Azure Data Factory",
        topics: [
          { title: "Pipelines", videoLink: "https://example.com/video6" },
          { title: "Linked Services", videoLink: "https://example.com/video7" },
          { title: "Triggers", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Azure Synapse Analytics",
        topics: [
          { title: "Warehousing and Analysis", videoLink: "https://example.com/video12" },
          // { title: "outlier treatment", videoLink: "https://example.com/video13" },
          //  { title: "deduplication", videoLink: "https://example.com/video14" },
          // { title: "Assignment operators", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Hands-on Lab",
        topics: [
          { title: "Ingest → Transform → Query on Synapse" , videoLink: "https://example.com/video19" },
          // { title: "seaborn for trend analysis", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      }
     
    ],
  },
  "Data Engineering with AWS"  : {
    name: "Data Engineering with AWS",
    modules: [
      {
        moduleTitle: "S3 for Data Storage",
        topics: [
          // { title: "Types of data" },
          // { title: "schema"},
          // { title: "metadata", videoLink: "https://example.com/video3" },
          // { title: "Installation of Anaconda Python", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Glue for ETL and Catalog",
        topics: [
          // { title: "Summary statistics", videoLink: "https://example.com/video6" },
          // { title: "missing values", videoLink: "https://example.com/video7" },
          // { title: "distributions", videoLink: "https://example.com/video8" },
          // // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Athena for Serverless SQL",
        topics: [
          // { title: "Null handling", videoLink: "https://example.com/video12" },
          // { title: "outlier treatment", videoLink: "https://example.com/video13" },
          //  { title: "deduplication", videoLink: "https://example.com/video14" },
          // { title: "Assignment operators", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Lambda for serverless transformations",
        topics: [
          // { title: "matplotlib" , videoLink: "https://example.com/video19" },
          // { title: "seaborn for trend analysis", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "EMR for Spark/Hadoop Jobs",
        topics: [
          // { title: "Analyze sales or user behavior dataset", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Redshift for Warehousing",
        topics: [
          // { title: "matplotlib" , videoLink: "https://example.com/video19" },
          // { title: "seaborn for trend analysis", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "Hands-on Lab",
        topics: [
           { title: "S3 → Glue ETL → Athena/Redshift Query", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
    ],
    
    
  },
  "Introduction to Cloud Platforms"  : {
    name: "Introduction to Cloud Platforms",
    modules: [
      {
        moduleTitle: "Why Cloud for Data Engineering?",
        topics: [
          // { title: "Types of data" },
          // { title: "schema"},
          // { title: "metadata", videoLink: "https://example.com/video3" },
          // { title: "Installation of Anaconda Python", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Overview",
        topics: [
          { title: "AWS", videoLink: "https://example.com/video6" },
          { title: "Azure", videoLink: "https://example.com/video7" },
          { title: "GCP", videoLink: "https://example.com/video8" },
          // // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Services Comparison",
        topics: [
          { title: "Storage", videoLink: "https://example.com/video12" },
          { title: "Compute", videoLink: "https://example.com/video13" },
           { title: "Orchestration", videoLink: "https://example.com/video14" },
          { title: "Monitoring", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Pricing and Free Tiers",
        topics: [
          // { title: "matplotlib" , videoLink: "https://example.com/video19" },
          // { title: "seaborn for trend analysis", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      } 
    ],
  },
   "Python Programming for Data Engineering"  : {
    name: "Python Programming for Data Engineering",
    modules: [
      {
        moduleTitle: "Fundamentals",
        topics: [
          { title: "Variables" },
          { title: "data types"},
          { title: "control structures (if, loops)", videoLink: "https://example.com/video3" },
          // { title: "Installation of Anaconda Python", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Data Structures",
        topics: [
          { title: "Lists", videoLink: "https://example.com/video6" },
          { title: "tuple", videoLink: "https://example.com/video7" },
          { title: "dictionaries", videoLink: "https://example.com/video8" },
           { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Functions & Modules",
        topics: [
          { title: "Writing reusable functions", videoLink: "https://example.com/video12" },
          { title: "importing packages", videoLink: "https://example.com/video13" },
          //  { title: "deduplication", videoLink: "https://example.com/video14" },
          // { title: "Assignment operators", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "File Handling",
        topics: [
          { title: "Reading/writing files (CSV, JSON, XML)" , videoLink: "https://example.com/video19" },
          // { title: "Free Tiers", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },  {
        moduleTitle: "Libraries for Data Engineering",
        topics: [
           { title: "pandas", videoLink: "https://example.com/video28" },
          { title: "numpy", videoLink: "https://example.com/video29" },
          { title: "os", videoLink: "https://example.com/video30" },
          { title: "glob", videoLink: "https://example.com/video31" },
          { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },  {
        moduleTitle: "Automation",
        topics: [
           { title: "Scripting ETL logic", videoLink: "https://example.com/video28" },
          { title: "logging", videoLink: "https://example.com/video29" },
          { title: "os", videoLink: "https://example.com/video30" },
          { title: "glob", videoLink: "https://example.com/video31" },
          { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
    
    ],
  },
  "Data Engineering with GCP"  : {
    name: "Data Engineering with GCP",
    modules: [
      {
        moduleTitle: "Cloud Storage, BigQuery",
        topics: [
          // { title: "Types of data" },
          // { title: "schema"},
          // { title: "metadata", videoLink: "https://example.com/video3" },
          // // { title: "Installation of Anaconda Python", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Dataflow Overview",
        topics: [
          { title: "AWS", videoLink: "https://example.com/video6" },
          { title: "Azure", videoLink: "https://example.com/video7" },
          { title: "GCP", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {

        moduleTitle: "Bigquery for Warehousing",

        topics: [
          // { title: "Null handling", videoLink: "https://example.com/video12" },
          // { title: "outlier treatment", videoLink: "https://example.com/video13" },
          //  { title: "deduplication", videoLink: "https://example.com/video14" },
          // { title: "Assignment operators", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Cloud Pub/Sub for Streaming",
        topics: [
          // { title: "Pricing" , videoLink: "https://example.com/video19" },
          // { title: "Free Tiers", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
    
    ],
    
    
  },
   "Apache Airflow for Workflow Orchestration"  : {
    name: "Apache Airflow for Workflow Orchestration",
    modules: [
      {
        moduleTitle: "Airflow Architecture",
        topics: [
          { title: "DAGs" },
          { title: "Tasks"},
          { title: "Operators", videoLink: "https://example.com/video3" },
           { title: "Executors", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Creating and Scheduling DAGs",
        topics: [
          // { title: "Summary statistics", videoLink: "https://example.com/video6" },
          // { title: "missing values", videoLink: "https://example.com/video7" },
          // { title: "distributions", videoLink: "https://example.com/video8" },
          //  { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Monitoring and Logging DAGs",
        topics: [
          { title: "Monitoring", videoLink: "https://example.com/video12" },
          { title: "Logging DAGs", videoLink: "https://example.com/video13" },
          //  { title: "deduplication", videoLink: "https://example.com/video14" },
          // { title: "Assignment operators", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Hands-on",
        topics: [
          { title: "Build a sample ETL pipeline with retries and notifications" , videoLink: "https://example.com/video19" },
          // { title: "seaborn for trend analysis", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
   
    ],
    
    
  },
  "Apache Kafka for Streaming Pipelines"  : {
    name: "Apache Kafka for Streaming Pipelines",
    modules: [
      {
        moduleTitle: "Pub-Sub Architecture, Topics, Partitions",
        topics: [
          { title: "Pub-Sub Architecture" },
          { title: "Topics"},
          { title: "Partitions", videoLink: "https://example.com/video3" },
          // { title: "Installation of Anaconda Python", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Kafka Producer and Consumer APIs",
        topics: [
          { title: "Kafka Producer APIs", videoLink: "https://example.com/video6" },
          { title: "Consumer APIs", videoLink: "https://example.com/video7" },
          // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Schema Registry, Avro, JSON",
        topics: [
          { title: "Schema Registry", videoLink: "https://example.com/video12" },
          { title: "Avro", videoLink: "https://example.com/video13" },
           { title: "JSON", videoLink: "https://example.com/video14" },
          // { title: "Assignment operators", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Hands-on",
        topics: [
          { title: "Simulate real-time events using Kafka + Python/Spark" , videoLink: "https://example.com/video19" },
          // { title: "seaborn for trend analysis", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
     
    ],
  },
  "Apache Spark for Scalable Data Processing"  : {
    name: "Apache Spark for Scalable Data Processing",
    modules: [
      {
        moduleTitle: "Spark Basics",
        topics: [
          { title: "RDDs" },
          { title: "Transformations & Actions "},
          // { title: "metadata", videoLink: "https://example.com/video3" },
          // { title: "Installation of Anaconda Python", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "DataFrames and SQL API",
        topics: [
          { title: "DataFrames", videoLink: "https://example.com/video6" },
          { title: "SQL API", videoLink: "https://example.com/video7" },
          // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Spark Structured Streaming",
        topics: [
          // { title: "Null handling", videoLink: "https://example.com/video12" },
          // { title: "outlier treatment", videoLink: "https://example.com/video13" },
          //  { title: "deduplication", videoLink: "https://example.com/video14" },
          // { title: "Assignment operators", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Distributed Computing Framework",
        topics: [
          { title: "Databricks Community Edition" , videoLink: "https://example.com/video19" },
          // { title: "seaborn for trend analysis", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "PySpark Hands-on",
        topics: [
          { title: "Read from files", videoLink: "https://example.com/video28" },
          { title: "transform", videoLink: "https://example.com/video29" },
         { title: "aggregate", videoLink: "https://example.com/video30" },
         { title: "write back", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
        {
        moduleTitle: "Performance Tuning and Lazy Evaluation",
        topics: [
        //   { title: "Read from files", videoLink: "https://example.com/video28" },
        //   { title: "transform", videoLink: "https://example.com/video29" },
        //  { title: "aggregate", videoLink: "https://example.com/video30" },
        //  { title: "write back", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
    ],
    
    
  },
   "Big Data Concepts and Hadoop Ecosystem"  : {
    name: "Big Data Concepts and Hadoop Ecosystem",
    modules: [
      {
        moduleTitle: "Understanding Big Data",
        topics: [
          { title: "5 Vs" },
          { title: "Challenges"},
          { title: "Opportunities", videoLink: "https://example.com/video3" },
          // { title: "Installation of Anaconda Python", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "HDFS Architecture",
        topics: [
          { title: "NameNode", videoLink: "https://example.com/video6" },
          { title: "DataNode", videoLink: "https://example.com/video7" },
          { title: "Block Storage", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "MapReduce Concept",
        topics: [
          // { title: "Null handling", videoLink: "https://example.com/video12" },
          // { title: "outlier treatment", videoLink: "https://example.com/video13" },
          //  { title: "deduplication", videoLink: "https://example.com/video14" },
          // { title: "Assignment operators", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Hadoop Ecosystem Tools",
        topics: [
          { title: "Hive" , videoLink: "https://example.com/video19" },
          { title: "Pig", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "Hands-on",
        topics: [
          { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
    ],
    
    
  },
  
  "Introduction to AI and Generative AI"  : {
    name: "Introduction to AI and Generative AI",
    modules: [
      {
        moduleTitle: "What is Artificial Intelligence?",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Traditional Programming vs AI",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Evolution to Generative AI",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {

        moduleTitle: "Difference between AI and Generative AI",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      // {
      //   moduleTitle: "Hands-on",
      //   topics: [
      //     { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
      //   //   { title: "numpy", videoLink: "https://example.com/video29" },
      //   //   { title: "os", videoLink: "https://example.com/video30" },
      //   //   { title: "glob", videoLink: "https://example.com/video31" },
      //   //   { title: "logging", videoLink: "https://example.com/video32" }
      //    ]
      // },
    ],
    
    
  },
   "Introduction to ML Engineering"  : {
    name: "Introduction to ML Engineering",
    modules: [
      {
        moduleTitle: "Understand the full lifecycle of a Machine Learning project",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Explore industry roles: ML Engineer, Data Scientist, MLOps Engineer",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Study the CRISP-ML(Q) framework and how it improves model quality",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Real-world ML systems: Batch vs real-time, data flow architecture",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      // {
      //   moduleTitle: "Hands-on",
      //   topics: [
      //     { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
      //   //   { title: "numpy", videoLink: "https://example.com/video29" },
      //   //   { title: "os", videoLink: "https://example.com/video30" },
      //   //   { title: "glob", videoLink: "https://example.com/video31" },
      //   //   { title: "logging", videoLink: "https://example.com/video32" }
      //    ]
      // },
    ],
    
    
  },
  // "Data Ingestion and Feature Engineering"  : {
  //   name: "Data Ingestion and Feature Engineering",
  //   modules: [
  //     {
  //       moduleTitle: "Implement preprocessing pipelines using Sklearn’s ColumnTransformer",
  //       topics: [
  //         // { title: "What is Artificial Intelligence?" },
  //         // { title: "Traditional Programming vs AI"},
  //         // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
  //         // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
  //         // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Write custom feature transformers using Scikit-learn",
  //       topics: [
  //         // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
  //         // { title: "How ANNs work", videoLink: "https://example.com/video7" },
  //         // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
  //         // { title: " sets", videoLink: "https://example.com/video9" },
  //         // { title: "Boolean", videoLink: "https://example.com/video10" },
  //         // { title: "Complex", videoLink: "https://example.com/video11" }
  //       ]
  //     },

  //     {
  //       moduleTitle: "Use Featuretools for automated feature engineering",
  //       topics: [
  //         // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
  //         // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
  //         // { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
  //         // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
  //         // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
  //         // { title: "Membership operators", videoLink: "https://example.com/video17" },
  //         // { title: "Identity operators", videoLink: "https://example.com/video18" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Introduction to Feature Stores and best practices",
  //       topics: [
  //         // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
  //         // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
  //         // // { title: "Tuple", videoLink: "https://example.com/video21" },
  //         // { title: "Sets", videoLink: "https://example.com/video22" },
  //         // { title: "Dictionary", videoLink: "https://example.com/video23" },
  //         // { title: "String Representation", videoLink: "https://example.com/video24" },
  //         // { title: "Arrays", videoLink: "https://example.com/video25" },
  //         // { title: "Matrix", videoLink: "https://example.com/video26" },
  //         // { title: "Datetime", videoLink: "https://example.com/video27" }
  //       ]
  //     },
      
  //   ],
    
    
  // },
  //  "ML Experimentation & Model Management"  : {
  //   name: "ML Experimentation & Model Management",
  //   modules: [
  //     {
  //       moduleTitle: "Evaluation Metrics",
  //       topics: [
  //         // { title: "What is Artificial Intelligence?" },
  //         // { title: "Traditional Programming vs AI"},
  //         // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
  //         // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
  //         // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Model evaluation: confusion matrix, ROC-AUC, precision-recall, RMSE, MAE",
  //       topics: [
  //         // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
  //         // { title: "How ANNs work", videoLink: "https://example.com/video7" },
  //         // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
  //         // { title: " sets", videoLink: "https://example.com/video9" },
  //         // { title: "Boolean", videoLink: "https://example.com/video10" },
  //         // { title: "Complex", videoLink: "https://example.com/video11" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Hyperparameter tuning using GridSearchCV, RandomSearchCV, and Optuna",
  //       topics: [
  //         // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
  //         // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
  //         //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
  //         // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
  //         // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
  //         // { title: "Membership operators", videoLink: "https://example.com/video17" },
  //         // { title: "Identity operators", videoLink: "https://example.com/video18" }
  //       ]
  //     },
  //     {

  //       moduleTitle: "Track experiments with MLflow: parameters, metrics, artifacts",
  //       topics: [
  //         // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
  //         // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
  //         // // { title: "Tuple", videoLink: "https://example.com/video21" },
  //         // { title: "Sets", videoLink: "https://example.com/video22" },
  //         // { title: "Dictionary", videoLink: "https://example.com/video23" },
  //         // { title: "String Representation", videoLink: "https://example.com/video24" },
  //         // { title: "Arrays", videoLink: "https://example.com/video25" },
  //         // { title: "Matrix", videoLink: "https://example.com/video26" },
  //         // { title: "Datetime", videoLink: "https://example.com/video27" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Set up DVC for dataset and model versioning with Git",
  //       topics: [
  //       //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
  //       //   { title: "numpy", videoLink: "https://example.com/video29" },
  //       //   { title: "os", videoLink: "https://example.com/video30" },
  //       //   { title: "glob", videoLink: "https://example.com/video31" },
  //       //   { title: "logging", videoLink: "https://example.com/video32" }
  //        ]
  //     },
  //     {
  //       moduleTitle: "Collaborative model management in teams",
  //       topics: [
  //       //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
  //       //   { title: "numpy", videoLink: "https://example.com/video29" },
  //       //   { title: "os", videoLink: "https://example.com/video30" },
  //       //   { title: "glob", videoLink: "https://example.com/video31" },
  //       //   { title: "logging", videoLink: "https://example.com/video32" }
  //        ]
  //     },

  //    ],
 
  // },
  // "Deploying ML Models"  : {
  //   name: "Deploying ML Models",
  //   modules: [
  //     {
  //       moduleTitle: "Compare batch, streaming, and real-time inference techniques",
  //       topics: [
  //         // { title: "What is Artificial Intelligence?" },
  //         // { title: "Traditional Programming vs AI"},
  //         // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
  //         // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
  //         // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Create REST APIs with FastAPI and Flask to serve models",
  //       topics: [
  //         // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
  //         // { title: "How ANNs work", videoLink: "https://example.com/video7" },
  //         // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
  //         // { title: " sets", videoLink: "https://example.com/video9" },
  //         // { title: "Boolean", videoLink: "https://example.com/video10" },
  //         // { title: "Complex", videoLink: "https://example.com/video11" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Model serialization using joblib, pickle, ONNX, and SavedModel",
  //       topics: [
  //         // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
  //         // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
  //         //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
  //         // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
  //         // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
  //         // { title: "Membership operators", videoLink: "https://example.com/video17" },
  //         // { title: "Identity operators", videoLink: "https://example.com/video18" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Dockerize ML services for portability and repeatability",
  //       topics: [
  //         // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
  //         // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
  //         // // { title: "Tuple", videoLink: "https://example.com/video21" },
  //         // { title: "Sets", videoLink: "https://example.com/video22" },
  //         // { title: "Dictionary", videoLink: "https://example.com/video23" },
  //         // { title: "String Representation", videoLink: "https://example.com/video24" },
  //         // { title: "Arrays", videoLink: "https://example.com/video25" },
  //         // { title: "Matrix", videoLink: "https://example.com/video26" },
  //         // { title: "Datetime", videoLink: "https://example.com/video27" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Intro to deploying on cloud platforms like Heroku, AWS EC2, GCP App Engine",
  //       topics: [
  //       //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
  //       //   { title: "numpy", videoLink: "https://example.com/video29" },
  //       //   { title: "os", videoLink: "https://example.com/video30" },
  //       //   { title: "glob", videoLink: "https://example.com/video31" },
  //       //   { title: "logging", videoLink: "https://example.com/video32" }
  //        ]
  //     },
  //    ],
  // },
  //  "Monitoring Models in Production"  : {
  //   name: "Monitoring Models in Production",
  //   modules: [
  //     {
  //       moduleTitle: "Detect model performance decay using concept drift and data drift techniques",
  //       topics: [
  //         // { title: "What is Artificial Intelligence?" },
  //         // { title: "Traditional Programming vs AI"},
  //         // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
  //         // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
  //         // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Use Evidently AI to generate performance reports",
  //       topics: [
  //         // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
  //         // { title: "How ANNs work", videoLink: "https://example.com/video7" },
  //         // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
  //         // { title: " sets", videoLink: "https://example.com/video9" },
  //         // { title: "Boolean", videoLink: "https://example.com/video10" },
  //         // { title: "Complex", videoLink: "https://example.com/video11" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Integrate Prometheus and Grafana for system and model monitoring",
  //       topics: [
  //         // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
  //         // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
  //         //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
  //         // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
  //         // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
  //         // { title: "Membership operators", videoLink: "https://example.com/video17" },
  //         // { title: "Identity operators", videoLink: "https://example.com/video18" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Capture logs and feedback data to trigger retraining cycles",
  //       topics: [
  //         // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
  //         // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
  //         // // { title: "Tuple", videoLink: "https://example.com/video21" },
  //         // { title: "Sets", videoLink: "https://example.com/video22" },
  //         // { title: "Dictionary", videoLink: "https://example.com/video23" },
  //         // { title: "String Representation", videoLink: "https://example.com/video24" },
  //         // { title: "Arrays", videoLink: "https://example.com/video25" },
  //         // { title: "Matrix", videoLink: "https://example.com/video26" },
  //         // { title: "Datetime", videoLink: "https://example.com/video27" }
  //       ]
  //     },
      
  //    ],
  // },
  //  "MLOps Workflow Automation"  : {
  //   name: "MLOps Workflow Automation",
  //   modules: [
  //     {
  //       moduleTitle: "Write DAGs in Apache Airflow to orchestrate ML workflows",
  //       topics: [
  //         // { title: "What is Artificial Intelligence?" },
  //         // { title: "Traditional Programming vs AI"},
  //         // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
  //         // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
  //         // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Schedule daily/weekly retraining and evaluation pipelines",
  //       topics: [
  //         // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
  //         // { title: "How ANNs work", videoLink: "https://example.com/video7" },
  //         // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
  //         // { title: " sets", videoLink: "https://example.com/video9" },
  //         // { title: "Boolean", videoLink: "https://example.com/video10" },
  //         // { title: "Complex", videoLink: "https://example.com/video11" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Intro to Kubeflow Pipelines for end-to-end workflow automation",
  //       topics: [
  //         // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
  //         // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
  //         //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
  //         // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
  //         // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
  //         // { title: "Membership operators", videoLink: "https://example.com/video17" },
  //         // { title: "Identity operators", videoLink: "https://example.com/video18" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Implement retry logic, notifications, and workflow checkpoints",
  //       topics: [
  //         // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
  //         // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
  //         // // { title: "Tuple", videoLink: "https://example.com/video21" },
  //         // { title: "Sets", videoLink: "https://example.com/video22" },
  //         // { title: "Dictionary", videoLink: "https://example.com/video23" },
  //         // { title: "String Representation", videoLink: "https://example.com/video24" },
  //         // { title: "Arrays", videoLink: "https://example.com/video25" },
  //         // { title: "Matrix", videoLink: "https://example.com/video26" },
  //         // { title: "Datetime", videoLink: "https://example.com/video27" }
  //       ]
  //     },
      
  //    ],
  // },
  // "Building CICD Pipelines"  : {
  //   name: "Building CI/CD Pipelines",
  //   modules: [
  //     {
  //       moduleTitle: "Understand DevOps and CI/CD concepts adapted for ML",
  //       topics: [
  //         // { title: "What is Artificial Intelligence?" },
  //         // { title: "Traditional Programming vs AI"},
  //         // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
  //         // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
  //         // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Create GitHub Actions for automated testing and model promotion",
  //       topics: [
  //         // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
  //         // { title: "How ANNs work", videoLink: "https://example.com/video7" },
  //         // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
  //         // { title: " sets", videoLink: "https://example.com/video9" },
  //         // { title: "Boolean", videoLink: "https://example.com/video10" },
  //         // { title: "Complex", videoLink: "https://example.com/video11" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Setup workflow for automatic deployment after model approval",
  //       topics: [
  //         // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
  //         // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
  //         //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
  //         // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
  //         // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
  //         // { title: "Membership operators", videoLink: "https://example.com/video17" },
  //         // { title: "Identity operators", videoLink: "https://example.com/video18" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Intro to SageMaker Pipelines, Vertex AI Pipelines, and Azure ML",
  //       topics: [
  //         // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
  //         // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
  //         // // { title: "Tuple", videoLink: "https://example.com/video21" },
  //         // { title: "Sets", videoLink: "https://example.com/video22" },
  //         // { title: "Dictionary", videoLink: "https://example.com/video23" },
  //         // { title: "String Representation", videoLink: "https://example.com/video24" },
  //         // { title: "Arrays", videoLink: "https://example.com/video25" },
  //         // { title: "Matrix", videoLink: "https://example.com/video26" },
  //         // { title: "Datetime", videoLink: "https://example.com/video27" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Intro to deploying on cloud platforms like Heroku, AWS EC2, GCP App Engine",
  //       topics: [
  //       //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
  //       //   { title: "numpy", videoLink: "https://example.com/video29" },
  //       //   { title: "os", videoLink: "https://example.com/video30" },
  //       //   { title: "glob", videoLink: "https://example.com/video31" },
  //       //   { title: "logging", videoLink: "https://example.com/video32" }
  //        ]
  //     },
  //    ],
  // },
   "Cloud Concepts & OCI Fundamentals"  : {
    name: "Cloud Concepts & OCI Fundamentals",
    modules: [
      {
        moduleTitle: "OCI 2025 Certification Path (Associate vs. Professional)",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Cloud Computing Essentials (NIST Model, OCI Architecture)",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Scalability vs. Elasticity (Auto-scaling, HPC, Serverless)",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "OCI Service Models (IaaS, PaaS, SaaS, Containers, Functions)",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "Cloud Deployment Models (Public, Hybrid, Multicloud, Dedicated Regions)",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
       {
        moduleTitle: "Oracle Cloud Free Tier & Paid Account Best Practices",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: " Labs:",
        topics: [
          { title: " Lab 1.1: Set Up OCI Free Tier with Budget Alerts & MFA", videoLink: "https://example.com/video28" },
          { title: "Lab 1.2: Explore OCI Console & Global Infrastructure", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
     ],
  },
   "Identity & Access Management (IAM) - Advanced"  : {
    name: "Identity & Access Management (IAM) - Advanced",
    modules: [
      {
        moduleTitle: "IAM 2025 Updates (Policies, Federation, Identity Domains)",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Users, Groups, Dynamic Groups & Instance Principals",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Compartment Design Strategies (Landing Zones, Tagging)",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Policy Deep Dive (Tenancy, Compartment, Advanced Conditions)",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "OCI Identity Domains (SSO, SAML, OAuth, RBAC vs. ABAC)",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
       {
        moduleTitle: "Cross-Tenancy Access & Resource Manager",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: " Labs:",
        topics: [
          { title: "Lab 2.1: Configure Custom IAM Policies with Terraform", videoLink: "https://example.com/video28" },
          { title: "Lab 2.2: Set Up OCI-ADFS Federation", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
     ],
  },
   "Compute & Edge Services"  : {
    name: "Compute & Edge Services",
    modules: [
      {
        moduleTitle: "Compute 2025 (Shapes: AMD, ARM, GPU, Flex)",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Bare Metal, VMs, & Container Instances",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Custom Images & Instance Pools",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Auto-scaling & OS Management (Oracle Linux, Windows)",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "OCI Functions & Serverless Best Practices",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
       {
        moduleTitle: "Edge Services (OCI DNS, WAAS, Web Application Firewall)",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Labs:",
        topics: [
          { title: "Deploy Auto-scaling Web Tier with Load Balancer", videoLink: "https://example.com/video28" },
          { title: "Serverless API with OCI Functions & API Gateway", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
     ],
  },
  "Python Fundamentals"  : {
    name: "Python Fundamentals",
    modules: [
      {
        moduleTitle: "Python Introduction",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Data Types ",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Operators in Python",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Data structures",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "Conditional Statements",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
       {
        moduleTitle: "Loops",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Functions",
        topics: [
          // { title: "Deploy Auto-scaling Web Tier with Load Balancer", videoLink: "https://example.com/video28" },
          // { title: "Serverless API with OCI Functions & API Gateway", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "File Handling",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "Exception Handling",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
       {
        moduleTitle: "Python Packages for Data Analysis",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Regular expressions",
        topics: [
          // { title: "Deploy Auto-scaling Web Tier with Load Balancer", videoLink: "https://example.com/video28" },
          // { title: "Serverless API with OCI Functions & API Gateway", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Data Collection and Data Wrangling",
        topics: [
          // { title: "Deploy Auto-scaling Web Tier with Load Balancer", videoLink: "https://example.com/video28" },
          // { title: "Serverless API with OCI Functions & API Gateway", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
     ],
  },
    "SQL Programming"  : {
    name: "SQL Programming",
    modules: [
      {
        moduleTitle: "DBMS Fundamentals",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Data Models and ACID properties",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "SQL commands",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "DDL and DML - User, Database, and Table creation",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "Clauses in DQL commands",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
       {
        moduleTitle: "Constraints - Primary, Foreign Key, Check constraints",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Joins, Union, and date time",
        topics: [
          // { title: "Deploy Auto-scaling Web Tier with Load Balancer", videoLink: "https://example.com/video28" },
          // { title: "Serverless API with OCI Functions & API Gateway", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Triggers",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "Views",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      }
    ]
  },
    "Experiment Tracking"  : {
    name: "Experiment Tracking",
    modules: [
      {
        moduleTitle: "Need for tracking experiments",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "MLflow basics: Tracking parameters, metrics, models",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "MLflow Tracking",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "MLflow Model",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "MLflow Evaluation",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
       {
        moduleTitle: "MLflow Model Registry",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "MLflow Serving",
        topics: [
          // { title: "Deploy Auto-scaling Web Tier with Load Balancer", videoLink: "https://example.com/video28" },
          // { title: "Serverless API with OCI Functions & API Gateway", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      }
    ]
  },
  "Versioning: Code, Data, and Models"  : {
    name: "Versioning: Code, Data, and Models",
    modules: [
      {
        moduleTitle: "Importance of reproducibility",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
       {
        moduleTitle: "Git for code versioning",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "DVC (Data Version Control) for dataset tracking",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Model versioning basics",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
    ]
  },
   "Model Deployment"  : {
    name: "Model Deployment",
    modules: [
      {
        moduleTitle: "Deployment options: Batch vs. Online vs. Edge",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
       {
        moduleTitle: "REST APIs for model serving (FastAPI/Flask basics)",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Serving a model locally",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      }
    ]
  },
    "CI/CD for ML"  : {
    name: "CI/CD for ML",
    modules: [
      {
        moduleTitle: "Jenkins, GitHub Actions: Basics",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
       {
        moduleTitle: "Building a simple CI/CD pipeline for an ML project",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      }
    ]
  },
   "Monitoring ML Models"  : {
    name: "Monitoring ML Models",
    modules: [
      {
        moduleTitle: "Data drift, Concept drift",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
       {
        moduleTitle: "Tools for monitoring",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      }
    ]
  },
    "Orchestration and Pipelines"  : {
    name: "Orchestration and Pipelines",
    modules: [
      {
        moduleTitle: "Workflow orchestration",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
       {
        moduleTitle: "Apache Airflow and Kubeflow Pipelines",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
       {
        moduleTitle: "Building a simple ML pipeline",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
    ]
  },
   "End-to-End MLOps Project"  : {
    name: "End-to-End MLOps Project",
    modules: [
      {
        moduleTitle: "MLOps cycle:",
        topics: [
          { title: "versioning" },
          { title: "training "},
          { title: "deployment ", videoLink: "https://example.com/video3" },
          { title: "monitoring", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      //  {
      //   moduleTitle: "Apache Airflow and Kubeflow Pipelines",
      //   topics: [
      //     // { title: "What is Artificial Intelligence?" },
      //     // { title: "Traditional Programming vs AI"},
      //     // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
      //     // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
      //     // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
      //   ]
      // },
      //  {
      //   moduleTitle: "Building a simple ML pipeline",
      //   topics: [
      //     // { title: "What is Artificial Intelligence?" },
      //     // { title: "Traditional Programming vs AI"},
      //     // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
      //     // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
      //     // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
      //   ]
      // },
    ]
  },
    "Containerizing"  : {
    name: "Containerizing",
    modules: [
      {
        moduleTitle: "Docker Basics",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
       {
        moduleTitle: "Docker Compose",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Docker Image and Docker Container",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      
    ]
  },
      "Introduction to MLOps"  : {
    name: "Introduction to MLOps",
    modules: [
      {
        moduleTitle: "Key differences between traditional ML and MLOps",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Stages of the ML Lifecycle",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      }
    ]
  },
  "Storage & Data Transfer"  : {
    name: "Storage & Data Transfer",
    modules: [
      {
        moduleTitle: "Block Volume (Performance Tiers, Encryption, Backup Policies)",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Object Storage (Tiers, Retention Rules, Data Lake)",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "File Storage (NFS, SMB, Snapshots)",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Storage Gateway & Data Transfer Appliance (DTA)",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "OCI Storage Replication (Cross-Region, DR Strategies)",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Labs:",
        topics: [
          { title: "Configure Multi-Attach Block Volume for HA", videoLink: "https://example.com/video28" },
          { title: "Data Migration from AWS S3 to OCI Object Storage", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
     ],
  },
   "Advanced Networking & Security"  : {
    name: "Advanced Networking & Security",
    modules: [
      {
        moduleTitle: "VCN Design (Hub-Spoke, Isolated Subnets, IPv6)",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "DRG Enhancements (Remote Peering, Multicast)",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
       {
        moduleTitle: "Network Security (NSGs, VCN Flow Logs, Network Firewall)",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Load Balancers (Public/Private, WAF Integration)",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "FastConnect & VPN (Performance, BGP Routing)",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "Network Observability (Traffic Mirroring, VCN TAP)",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Labs:",
        topics: [
          { title: "Build Hybrid Cloud with FastConnect & On-Premises", videoLink: "https://example.com/video28" },
          { title: " Secure Web App with WAF & DDoS Protection", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
     ],
  },
  "Databases in OCI (2025 Updates)"  : {
    name: " Databases in OCI (2025 Updates)",
    modules: [
      {
        moduleTitle: "Autonomous Database (ATP, ADW, JSON, ML)",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Exadata Cloud@Customer & Dedicated Regions",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
       {
        moduleTitle: "MySQL HeatWave & NoSQL Database",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Database Migration (ZDM, GoldenGate, DMS)",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Backup & DR (Data Guard, Autonomous Backup)",
        topics: [
          // { title: "Text Mining Basics" , videoLink: "https://example.com/video19" },
          // { title: "Natural Language Processing (NLP) Overview", videoLink: "https://example.com/video20" },
          // // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      
      {
        moduleTitle: "Labs:",
        topics: [
          { title: "Deploy ATP with APEX & Machine Learning", videoLink: "https://example.com/video28" },
          { title: "Migrate On-Prem DB to OCI using ZDM", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
     ],
  },
  "Security, Observability & Governance"  : {
    name: "Security, Observability & Governance",
    modules: [
      {
        moduleTitle: "OCI Security Zones & Cloud Guard",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Logging & Monitoring (OCI Metrics, Alarms, Notifications)",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
       {
        moduleTitle: "OCI Certificates & Key Management (Vault, HSM)",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Cost Management (Budgets, Usage Reports, Tagging)",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
     
      
      {
        moduleTitle: "Labs:",
        topics: [
          { title: "Detect Threats with Cloud Guard & Responder", videoLink: "https://example.com/video28" },
          { title: "Optimize Costs with Cost Analysis Reports", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
     ],
  },
    "Migration & Modernization"  : {
    name: "Migration & Modernization",
    modules: [
      {
        moduleTitle: "OCI Migration Framework (Assess, Plan, Migrate)",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Lift-and-Shift (OCI VMware Solution, Ravello)",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
       {
        moduleTitle: "Refactoring Apps (Containers, Kubernetes, DevOps)",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Legacy App Migration to OCI",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
     ],
  },
  "Certification Prep & Mock Exams"  : {
    name: "Certification Prep & Mock Exams",
    modules: [
      {
        moduleTitle: "Exam Blueprint (2025 Changes)",
        topics: [
          // { title: "What is Artificial Intelligence?" },
          // { title: "Traditional Programming vs AI"},
          // { title: "Evolution to Generative AI", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Scenario-Based Practice Questions",
        topics: [
          // { title: "Introduction to Neural Networks (ANNs)", videoLink: "https://example.com/video6" },
          // { title: "How ANNs work", videoLink: "https://example.com/video7" },
          // { title: "ANN vs CNN vs RNN", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
       {
        moduleTitle: "Interview Tips (Architect Role)",
        topics: [
        //   { title: "Use pseudo-distributed Hadoop with basic commands", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
      {
        moduleTitle: "Timed 50-Question Test",
        topics: [
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video12" },
          // { title: "Introduction to RNNs", videoLink: "https://example.com/video13" },
          //  { title: "LSTM: Long Short-Term Memory Networks", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
     ],
  },
  "Prompt Engineering"  : {
    name: "Prompt Engineering",
    modules: [
      {
        moduleTitle: "What is Prompt Engineering?",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Prompt Patterns and Templates",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Zero-shot, Few-shot, and Chain-of-Thought Prompting",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ],
    
    
  },
   "Foundations of ML Engineering"  : {
    name: "Foundations of ML Engineering",
    modules: [
      {
        moduleTitle: "Lifecycle of a Machine Learning Project",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "CRISP-ML(Q) vs CRISP-DM",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Roles: Data Scientist vs ML Engineer vs MLOps",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }
      ,
      {
        moduleTitle: "Batch vs Streaming Pipelines",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Data Flow Architecture for ML Systems",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ],
    
    
  },
   "Python for ML Engineering"  : {
    name: "Python for ML Engineering",
    modules: [
      {
        moduleTitle: "Functions, Pandas, NumPy, List Comprehensions",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Exploratory Data Analysis (EDA)",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Writing reusable, modular ML code",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }
      ,
      {
        moduleTitle: "Clean code, PEP-8, exception handling",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Unit testing with pytest",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ],
    
    
  },
   "Unsupervised & Supervised Learning"  : {
    name: "Unsupervised & Supervised Learning",
    modules: [
      {
        moduleTitle: "Clustering (KMeans, DBSCAN), PCA",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Regression (Linear, Logistic)",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Classification (DT, RF, XGBoost)",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }
      ,
      {
        moduleTitle: "Classification (DT, RF, XGBoost)",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Model validation (Cross-validation, GridSearchCV, Optuna)",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ],
    
    
  },
  "Feature Engineering"  : {
    name: "Feature Engineering",
    modules: [
      {
        moduleTitle: "ColumnTransformer, Pipelines",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Handling missing data, Encoding techniques",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Feature scaling and normalization",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }
      ,
      {
        moduleTitle: "Featuretools for auto feature generation",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Intro to Feature Stores",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ],
    
    
  },
    "ML Experimentation & Versioning"  : {
    name: "ML Experimentation & Versioning",
    modules: [
      {
        moduleTitle: "MLflow: experiment tracking, logging metrics, saving models",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Dataset versioning using DVC with Git",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Model comparison and performance tracking",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }
      ,
      {
        moduleTitle: "Collaborative team workflows",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ],
    
    
  },
     "Deployment & APIs"  : {
    name: "Deployment & APIs",
    modules: [
      {
        moduleTitle: "REST API with Flask, FastAPI and Streamlit",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Model serialization: Pickle, Joblib, ONNX",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Dockerizing ML APIs",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }
      ,
      {
        moduleTitle: "Deploying to AWS SageMaker with Notebook",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ],
    
    
  },
   "Data Engineering for ML Pipelines"  : {
    name: "Data Engineering for ML Pipelines",
    modules: [
      {
        moduleTitle: "ETL vs ELT: Concepts and differences",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Ingesting and transforming data using Pandas, SQLAlchemy",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Serverless ETL with AWS Glue",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }
      ,
      {
        moduleTitle: "Data warehousing with Redshift",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Serverless querying with Athena + S3",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ]
    
    
  },
  "Workflow Orchestration & CI-CD"  : {
    name: "Workflow Orchestration & CI-CD",
    modules: [
      {
        moduleTitle: "DAG design and orchestration with Apache Airflow",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Scheduling retraining pipelines",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "CI/CD for ML using GitHub Actions",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }
      ,
      {
        moduleTitle: "Automating deployment pipelines",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Serverless querying with Athena + S3",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ]
    
    
  },
   "Monitoring & MLOps"  : {
    name: "Monitoring & MLOps",
    modules: [
      {
        moduleTitle: "Data & Concept Drift detection",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Production monitoring using Evidently AI",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Retraining triggers and feedback loops with Airflow",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ]
    
    
  },
     "ML Capstone Project"  : {
    name: "ML Capstone Project",
    modules: [
      {
        moduleTitle: "Understanding the Problem Statement and Planning the ML Worflow",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Documenting the requirements with Project Charter and getting approval from Project Sponsor",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Documenting the Plan with CRISP-ML(Q) Template ",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }
      ,
      {
        moduleTitle: "Design the Data Flow Architecture with Draw.io",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Developing the Data ingestion (S3, Glue, Pandas) Pipeline",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },{
        moduleTitle: "Model development – Experimenting and tracking (MLflow)",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Packaging and Saving the Python Code to Code Repository for Deployment",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }
      ,
      {
        moduleTitle: "API serving (FastAPI/Flask)",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "CI/CD and orchestration (GitHub Actions + Airflow)",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
       {
        moduleTitle: "Deployment (Docker + AWS SageMaker)",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Monitoring and retraining logic",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },

    ]
    
    
  },
  "Retrieval-Augmented Generation (RAG)"  : {
    name: "Retrieval-Augmented Generation (RAG)",
    modules: [
      {
        moduleTitle: "Introduction to RAG",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Components and Features of RAG",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Optimization Techniques for RAG",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ],
    
    
  },
  "Frameworks and LLM Applications"  : {
    name: "Frameworks and LLM Applications",
    modules: [
      {
        moduleTitle: "Tools: Hugging Face, LangChain, OpenAI API",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Low-code platforms like LangFlow",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Creating Custom LLM Workflows",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ],
    
    
  },
  "Building AI Agents"  : {
    name: "Building AI Agents",
    modules: [
      {
        moduleTitle: "What are AI Agents?",
        topics: [
          // { title: "What is Prompt Engineering?" },
          // { title: "Prompt Patterns and Templates"},
          // { title: "Zero-shot, Few-shot, and Chain-of-Thought Prompting", videoLink: "https://example.com/video3" },
          // { title: "Difference between AI and Generative AI", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Steps to Create an Agent",
        topics: [
          // { title: "Introduction to RAG", videoLink: "https://example.com/video6" },
          // { title: "Components and Features of RAG", videoLink: "https://example.com/video7" },
          // { title: "Optimization Techniques for RAG", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Integrating APIs and Tools",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Designing Agent Workflows",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Error Recovery and Collaboration",
        topics: [
          // { title: "Tools: Hugging Face, LangChain, OpenAI API", videoLink: "https://example.com/video12" },
          // { title: "Low-code platforms like LangFlow", videoLink: "https://example.com/video13" },
          //  { title: "Integrating APIs and Tools", videoLink: "https://example.com/video14" },
          //  { title: "Creating Custom LLM Workflows", videoLink: "https://example.com/video14" },
          // { title: "GRU: Gated Recurrent Units", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      }

    ],
    
    
  },
  "Data Sources and NoSQL Databases"  : {
    name: "Data Sources and NoSQL Databases",
    modules: [
      {
        moduleTitle: "Introduction to NoSQL",
        topics: [
          { title: "Key-Value" },
          { title: "Document"},
          { title: "Columnar", videoLink: "https://example.com/video3" },
          { title: "Graph", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "MongoDB",
        topics: [
          { title: "CRUD operations", videoLink: "https://example.com/video6" },
          { title: "aggregation", videoLink: "https://example.com/video7" },
          { title: "indexing", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "When to choose NoSQL vs RDBMS",
        topics: [
          { title: "NoSQL", videoLink: "https://example.com/video12" },
          { title: "RDBMS", videoLink: "https://example.com/video13" },
          //  { title: "deduplication", videoLink: "https://example.com/video14" },
          // { title: "Assignment operators", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Streaming vs Batch Sources",
        topics: [
          { title: "Streaming" , videoLink: "https://example.com/video19" },
          { title: "Batch Sources", videoLink: "https://example.com/video20" },
          // { title: "Tuple", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      }
    
    ],
     
  },
  "Final Capstone Project (Optional)": {
    name: "Final Capstone Project (Optional)",
    modules: [
      {
        moduleTitle: "Objective",
        topics: [
          { title: "Design and implement a full ETL/ELT pipeline using cloud + big data tools" },
          // { title: "Document"},
          // { title: "Columnar", videoLink: "https://example.com/video3" },
          // { title: "Graph", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Options:",
        topics: [
          { title: "IoT streaming data ingestion (Kafka + Spark + Airflow)", videoLink: "https://example.com/video6" },
          { title: "Web log processing (Batch ETL on AWS/Azure/GCP)", videoLink: "https://example.com/video7" },
          { title: "Real-time sales dashboard using Spark + NoSQL + Power BI/Tableau", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
    ],  
  },
    

  "Introduction to Data Engineering"  : {
    name: "Introduction to Data Engineering",
    modules: [
      {
        moduleTitle: "What is Data Engineering?",
        topics: [
          // { title: "Types of data" },
          // { title: "schema"},
          // { title: "metadata", videoLink: "https://example.com/video3" },
          // { title: "Installation of Anaconda Python", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "ETL vs ELT vs ELTL",
        topics: [
          // { title: "Summary statistics", videoLink: "https://example.com/video6" },
          // { title: "missing values", videoLink: "https://example.com/video7" },
          // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Workflow Orchestration",
        topics: [
          { title: "Data Lifecycle", videoLink: "https://example.com/video12" },
          { title: "Pipelines", videoLink: "https://example.com/video13" },
           { title: "Workflows", videoLink: "https://example.com/video14" },
          // { title: "Assignment operators", videoLink: "https://example.com/video15" },
          // { title: "Bitwise operators", videoLink: "https://example.com/video16" },
          // { title: "Membership operators", videoLink: "https://example.com/video17" },
          // { title: "Identity operators", videoLink: "https://example.com/video18" }
        ]
      },
      {
        moduleTitle: "Types of Data",
        topics: [
          { title: "Structured" , videoLink: "https://example.com/video19" },
          { title: "Semi-Structured", videoLink: "https://example.com/video20" },
          { title: "Unstructured", videoLink: "https://example.com/video21" },
          // { title: "Sets", videoLink: "https://example.com/video22" },
          // { title: "Dictionary", videoLink: "https://example.com/video23" },
          // { title: "String Representation", videoLink: "https://example.com/video24" },
          // { title: "Arrays", videoLink: "https://example.com/video25" },
          // { title: "Matrix", videoLink: "https://example.com/video26" },
          // { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
      {
        moduleTitle: "Role of a Data Engineer vs Data Scientist vs Analyst",
        topics: [
          // { title: "Analyze sales or user behavior dataset", videoLink: "https://example.com/video28" },
        //   { title: "numpy", videoLink: "https://example.com/video29" },
        //   { title: "os", videoLink: "https://example.com/video30" },
        //   { title: "glob", videoLink: "https://example.com/video31" },
        //   { title: "logging", videoLink: "https://example.com/video32" }
         ]
      },
    ],
  },
  
   "The Transformer Revolution"  : {
    name: "The Transformer Revolution",
    modules: [
      {
        moduleTitle: "Why Transformers replaced RNNs",
        topics: [
          // { title: "Why Transformers replaced RNNs" },
          // { title: "Encoder-Decoder Architecture"},
          // { title: "Seq2Seq and Attention Mechanism", videoLink: "https://example.com/video3" },
          // { title: "Transformer Architecture", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Encoder-Decoder Architecture",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Seq2Seq and Attention Mechanism",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
       {
        moduleTitle: "Transformer Architecture",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      
    ],
    
    
  },
  "Sequence Models"  : {
    name: "Sequence Models",
    modules: [
      {
        moduleTitle: "Introduction to RNNs",
        topics: [
          // { title: "Why Transformers replaced RNNs" },
          // { title: "Encoder-Decoder Architecture"},
          // { title: "Seq2Seq and Attention Mechanism", videoLink: "https://example.com/video3" },
          // { title: "Transformer Architecture", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "History and Limitations of RNNs",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "LSTM: Long Short-Term Memory Networks",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
       {
        moduleTitle: "GRU: Gated Recurrent Units",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      
    ],
    
    
  },
  "Introduction to NLP"  : {
    name: "Introduction to NLP",
    modules: [
      {
        moduleTitle: "Text Mining Basics",
        topics: [
          // { title: "Why Transformers replaced RNNs" },
          // { title: "Encoder-Decoder Architecture"},
          // { title: "Seq2Seq and Attention Mechanism", videoLink: "https://example.com/video3" },
          // { title: "Transformer Architecture", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Natural Language Processing (NLP) Overview",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      }
      
    ],
  },
  "Neural Networks Basics"  : {
    name: "Neural Networks Basics",
    modules: [
      {
        moduleTitle: "Introduction to Neural Networks (ANNs)",
        topics: [
          // { title: "Why Transformers replaced RNNs" },
          // { title: "Encoder-Decoder Architecture"},
          // { title: "Seq2Seq and Attention Mechanism", videoLink: "https://example.com/video3" },
          // { title: "Transformer Architecture", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "How ANNs work",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "ANN vs CNN vs RNN",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      }
      
    ],
    
    
  },
  "Language Models"  : {
    name: "Language Models",
    modules: [
      {
        moduleTitle: "BERT: Bidirectional Encoder Representations from Transformers",
        topics: [
          // { title: "Why Transformers replaced RNNs" },
          // { title: "Encoder-Decoder Architecture"},
          // { title: "Seq2Seq and Attention Mechanism", videoLink: "https://example.com/video3" },
          // { title: "Transformer Architecture", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "GPT: Generative Pretrained Transformers",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "ANN vs CNN vs RNN",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      }
      
    ],
    
    
  },
  // "Software Engineering for ML"  : {
  //   name: "Software Engineering for ML",
  //   modules: [
  //     {
  //       moduleTitle: "Setup Git and GitHub for collaborative development",
  //       topics: [
  //         // { title: "Why Transformers replaced RNNs" },
  //         // { title: "Encoder-Decoder Architecture"},
  //         // { title: "Seq2Seq and Attention Mechanism", videoLink: "https://example.com/video3" },
  //         // { title: "Transformer Architecture", videoLink: "https://example.com/video4" },
  //         // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Design modular, reusable ML code with environment isolation (venv/conda)",
  //       topics: [
  //         // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
  //         // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
  //         // // { title: "distributions", videoLink: "https://example.com/video8" },
  //         // { title: " sets", videoLink: "https://example.com/video9" },
  //         // { title: "Boolean", videoLink: "https://example.com/video10" },
  //         // { title: "Complex", videoLink: "https://example.com/video11" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Implement clean code principles and PEP-8 standards",
  //       topics: [
  //         // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
  //         // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
  //         // // { title: "distributions", videoLink: "https://example.com/video8" },
  //         // { title: " sets", videoLink: "https://example.com/video9" },
  //         // { title: "Boolean", videoLink: "https://example.com/video10" },
  //         // { title: "Complex", videoLink: "https://example.com/video11" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Write unit tests for pipelines and functions using pytest",
  //       topics: [
  //         // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
  //         // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
  //         // // { title: "distributions", videoLink: "https://example.com/video8" },
  //         // { title: " sets", videoLink: "https://example.com/video9" },
  //         // { title: "Boolean", videoLink: "https://example.com/video10" },
  //         // { title: "Complex", videoLink: "https://example.com/video11" }
  //       ]
  //     },
  //     {
  //       moduleTitle: "Explore error handling, logging, and debugging best practices",
  //       topics: [
  //         // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
  //         // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
  //         // // { title: "distributions", videoLink: "https://example.com/video8" },
  //         // { title: " sets", videoLink: "https://example.com/video9" },
  //         // { title: "Boolean", videoLink: "https://example.com/video10" },
  //         // { title: "Complex", videoLink: "https://example.com/video11" }
  //       ]
  //     }
      
  //   ],
    
    
  // },
  
  "Generative Models"  : {
    name: "Generative Models",
    modules: [
      {
        moduleTitle: "Introduction to Generative Architectures",
        topics: [
          // { title: "Why Transformers replaced RNNs" },
          // { title: "Encoder-Decoder Architecture"},
          // { title: "Seq2Seq and Attention Mechanism", videoLink: "https://example.com/video3" },
          // { title: "Transformer Architecture", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "GANs: Generative Adversarial Networks",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Autoencoders",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Diffusion Models",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      
    ],
    
    
  },
  "Introduction to LLMs"  : {
    name: "Introduction to LLMs",
    modules: [
      {
        moduleTitle: "What are Large Language Models?",
        topics: [
          // { title: "Why Transformers replaced RNNs" },
          // { title: "Encoder-Decoder Architecture"},
          // { title: "Seq2Seq and Attention Mechanism", videoLink: "https://example.com/video3" },
          // { title: "Transformer Architecture", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Zero-Shot, Fine-Tuned, and Domain-Specific Models",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Model Evaluation and Benchmarks",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      }
      
    ],
  },
  "Customization and Optimization"  : {
    name: "Customization and Optimization",
    modules: [
      {
        moduleTitle: "Hyperparameters of LLMs",
        topics: [
          // { title: "Why Transformers replaced RNNs" },
          // { title: "Encoder-Decoder Architecture"},
          // { title: "Seq2Seq and Attention Mechanism", videoLink: "https://example.com/video3" },
          // { title: "Transformer Architecture", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Regularization Techniques",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Customization using Embeddings",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      }
      
    ],
    
    
  },
  "Real-World Challenges with LLMs"  : {
    name: "Real-World Challenges with LLMs",
    modules: [
      {
        moduleTitle: "Performance, Cost, and Infrastructure (GPU)",
        topics: [
          // { title: "Why Transformers replaced RNNs" },
          // { title: "Encoder-Decoder Architecture"},
          // { title: "Seq2Seq and Attention Mechanism", videoLink: "https://example.com/video3" },
          // { title: "Transformer Architecture", videoLink: "https://example.com/video4" },
          // { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Hallucinations: Need, Types (Intrinsic & Extrinsic), and Detection",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      {
        moduleTitle: "Foundation Models vs Small Language Models",
        topics: [
          // { title: "BERT: Bidirectional Encoder Representations from Transformers", videoLink: "https://example.com/video6" },
          // { title: "GPT: Generative Pretrained Transformers", videoLink: "https://example.com/video7" },
          // // { title: "distributions", videoLink: "https://example.com/video8" },
          // { title: " sets", videoLink: "https://example.com/video9" },
          // { title: "Boolean", videoLink: "https://example.com/video10" },
          // { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      }
      
    ],
    
  },
  "Python for Data Analytics": {
    name: "Python for Data Analytics",
    modules: [
      {
        moduleTitle: "Python Introduction",
        topics: [
          { title: "Introduction to Python Programming" },
          { title: "Installation of Python & Associated packages"},
          { title: "Graphical User Interface", videoLink: "https://example.com/video3" },
          { title: "Installation of Anaconda Python", videoLink: "https://example.com/video4" },
          { title: "Setting Up Python Environment", videoLink: "https://example.com/video5" }
        ]
      },
      {
        moduleTitle: "Data Types",
        topics: [
          { title: "Primitive vs Non-Premitive", videoLink: "https://example.com/video6" },
          { title: "Integer", videoLink: "https://example.com/video7" },
          { title: "Float", videoLink: "https://example.com/video8" },
          { title: "String", videoLink: "https://example.com/video9" },
          { title: "Boolean", videoLink: "https://example.com/video10" },
          { title: "Complex", videoLink: "https://example.com/video11" }
        ]
      },
      // {
      //   moduleTitle: "Operators in Python",
      //   topics: [
      //     { title: "Arithmetic operators", videoLink: "https://example.com/video12" },
      //     { title: "Relational operators", videoLink: "https://example.com/video13" },
      //     { title: "Logical operators", videoLink: "https://example.com/video14" },
      //     { title: "Assignment operators", videoLink: "https://example.com/video15" },
      //     { title: "Bitwise operators", videoLink: "https://example.com/video16" },
      //     { title: "Membership operators", videoLink: "https://example.com/video17" },
      //     { title: "Identity operators", videoLink: "https://example.com/video18" }
      //   ]
      // },
      {
        moduleTitle: "Data Structures",
        topics: [
          { title: "1D vs 2D data structures", videoLink: "https://example.com/video19" },
          { title: "Lists", videoLink: "https://example.com/video20" },
          { title: "Tuple", videoLink: "https://example.com/video21" },
          { title: "Sets", videoLink: "https://example.com/video22" },
          { title: "Dictionary", videoLink: "https://example.com/video23" },
          { title: "String Representation", videoLink: "https://example.com/video24" },
          { title: "Arrays", videoLink: "https://example.com/video25" },
          { title: "Matrix", videoLink: "https://example.com/video26" },
          { title: "Datetime", videoLink: "https://example.com/video27" }
        ]
      },
   
      {
        moduleTitle: "Loops",
        topics: [
          { title: "Finite vs Infinite loops", videoLink: "https://example.com/video33" },
          { title: "For loop", videoLink: "https://example.com/video34" },
          { title: "while loop", videoLink: "https://example.com/video35" },
          { title: "Nested loop", videoLink: "https://example.com/video36" },
          { title: "Control statement", videoLink: "https://example.com/video37" },
          { title: "pass", videoLink: "https://example.com/video38" },
          { title: "continue", videoLink: "https://example.com/video39" },
          { title: "break", videoLink: "https://example.com/video40" }
        ]
      },
      {
        moduleTitle: "Conditional Statements",
        topics: [
          { title: "if statement", videoLink: "https://example.com/video28" },
          { title: "if - else statement", videoLink: "https://example.com/video29" },
          { title: "if - elif statement", videoLink: "https://example.com/video30" },
          { title: "Nested if-else", videoLink: "https://example.com/video31" },
          { title: "Case", videoLink: "https://example.com/video32" }
        ]
      },
      {
        moduleTitle: "Functions",
        topics: [
          { title: "Purpose of a function", videoLink: "https://example.com/video41" },
          { title: "Defining a function", videoLink: "https://example.com/video42" },
          { title: "Calling a function", videoLink: "https://example.com/video43" },
          { title: "Function parameter passing", videoLink: "https://example.com/video44" },
          { title: "Formal arguments", videoLink: "https://example.com/video45" },
          { title: "Actual arguments", videoLink: "https://example.com/video46" },
          { title: "Positional arguments", videoLink: "https://example.com/video47" },
          { title: "Keyword arguments", videoLink: "https://example.com/video48" },
          { title: "Variable arguments", videoLink: "https://example.com/video49" },
          { title: "Variable keyword arguments", videoLink: "https://example.com/video50" },
          { title: "Use-Case *args, **kwargs", videoLink: "https://example.com/video51" },
          { title: "Function call stack", videoLink: "https://example.com/video52" },
          { title: "Locals()", videoLink: "https://example.com/video53" },
          { title: "Globals()", videoLink: "https://example.com/video54" },
          { title: "Lambda functions", videoLink: "https://example.com/video55" },
          { title: "Build-in Functions", videoLink: "https://example.com/video56" },
          { title: "Importing functions from another file", videoLink: "https://example.com/video57" }
        ]
      },
      // {
      //   moduleTitle: "Comprehensions",
      //   topics: [
      //     { title: "List comprehension", videoLink: "https://example.com/video58" },
      //     { title: "Dictionary comprehension", videoLink: "https://example.com/video59" },
      //     { title: "Enumerate", videoLink: "https://example.com/video60" },
      //     { title: "Zip and unzip", videoLink: "https://example.com/video61" },
      //     { title: "Loop vs Comprehension vs Lambda", videoLink: "https://example.com/video62" }
      //   ]
      // },
      {
        moduleTitle: "File Handling",
        topics: [
          { title: "CSV", videoLink: "https://example.com/video63" },
          { title: "Excel", videoLink: "https://example.com/video64" }
        ]
      },
      {
        moduleTitle: "Error Handling",
        topics: [
          { title: "Built-in Exceptions", videoLink: "https://example.com/video65" },
          { title: "Try and Exception blocks", videoLink: "https://example.com/video66" },
          { title: "User defined Exceptions", videoLink: "https://example.com/video67" },
          { title: "Handling Missing Keys", videoLink: "https://example.com/video68" }
        ]
      },
      {
        moduleTitle: "Python Package for Data Analysis",
        topics: [
          { title: "Numpy – Arrays, Memory, Matrices, Broadcasting, Masked Arrays", videoLink: "https://example.com/video69" },
          { title: "Pandas – Series, Dataframes", videoLink: "https://example.com/video70" },
          { title: "Matplotlib", videoLink: "https://example.com/video71" },
          { title: "Seaborn", videoLink: "https://example.com/video72" }
        ]
      },
      // {
      //   moduleTitle: "Data Visualization",
      //   topics: [
      //     { title: "Line Chart", videoLink: "https://example.com/video73" },
      //     { title: "Bar Chart", videoLink: "https://example.com/video74" },
      //     { title: "Histogram", videoLink: "https://example.com/video75" },
      //     { title: "Pie Charts", videoLink: "https://example.com/video76" },
      //     { title: "Box Plots", videoLink: "https://example.com/video77" },
      //     { title: "Scatter Plots", videoLink: "https://example.com/video78" },
      //     { title: "Figures & Subplots", videoLink: "https://example.com/video79" },
      //     { title: "Additional Visualization Packages", videoLink: "https://example.com/video80" }
      //   ]
      // },
      // {
      //   moduleTitle: "Regular Expression",
      //   topics: [
      //     { title: "re() package", videoLink: "https://example.com/video81" },
      //     { title: "sub", videoLink: "https://example.com/video82" },
      //     { title: "findall", videoLink: "https://example.com/video83" },
      //     { title: "split", videoLink: "https://example.com/video84" }
      //   ]
      // },
      // {
      //   moduleTitle: "Data Collection and Data Wrangling",
      //   topics: [
      //     { title: "Typecasting", videoLink: "https://example.com/video85" },
      //     { title: "Handling Duplicates & Categorical Data", videoLink: "https://example.com/video86" },
      //     { title: "Transformations", videoLink: "https://example.com/video87" },
      //     { title: "Imputation", videoLink: "https://example.com/video88" }
      //   ]
      // }
    ]
  },
    
  sql: {
    name: "SQL",
    modules: [
      {
        moduleTitle: "DBMS Fundamentals",
        topics: [
          {
            title: "DBMS Introduction",
            videoLink: "https://dummyvideo.com/dbms-intro"
          },
          {
            title: "Advantages of DBMS",
            videoLink: "https://dummyvideo.com/dbms-advantages"
          }
        ]
      },
      {
        moduleTitle: "Data Models and ACID properties",
        topics: [
          {
            title: "Types of Data Models",
            videoLink: "https://dummyvideo.com/data-models"
          },
          {
            title: "ACID Properties Explained",
            videoLink: "https://dummyvideo.com/acid-properties"
          }
        ]
      },
      {
        moduleTitle: "SQL commands",
        topics: [
          {
            title: "Types of SQL Commands",
            videoLink: "https://dummyvideo.com/sql-commands"
          }
        ]
      },
      {
        moduleTitle: "DDL and DML - User, Database, and Table creation",
        topics: [
          {
            title: "DDL Commands with Examples",
            videoLink: "https://dummyvideo.com/ddl-examples"
          },
          {
            title: "DML Commands with Examples",
            videoLink: "https://dummyvideo.com/dml-examples"
          },
          {
            title: "User, Database, and Table Creation",
            videoLink: "https://dummyvideo.com/db-creation"
          }
        ]
      },
      {
        moduleTitle: "Clauses in DQL commands",
        topics: [
          {
            title: "WHERE, GROUP BY, ORDER BY",
            videoLink: "https://dummyvideo.com/dql-clauses"
          }
        ]
      },
      {
        moduleTitle: "Constraints - Primary, Foreign Key, Check constraints",
        topics: [
          {
            title: "Primary Key Constraint",
            videoLink: "https://dummyvideo.com/primary-key"
          },
          {
            title: "Foreign Key Constraint",
            videoLink: "https://dummyvideo.com/foreign-key"
          },
          {
            title: "Check Constraint",
            videoLink: "https://dummyvideo.com/check-constraint"
          }
        ]
      }
    ]
  },
  "sql for Data Handling": {
    name: "SQL for Data Handling",
    modules: [
      {
        moduleTitle: "RDBMS Fundamentals",
        topics: [
          {
            title: "RDBMS Introduction",
            videoLink: "https://dummyvideo.com/dbms-intro"
          },
          {
            title: "Advantages of DBMS",
            videoLink: "https://dummyvideo.com/dbms-advantages"
          }
        ]
      },
      {
        moduleTitle: "Schema Design",
        topics: [
          {
            title: "Types of Data Models",
            videoLink: "https://dummyvideo.com/data-models"
          },
          {
            title: "ACID Properties Explained",
            videoLink: "https://dummyvideo.com/acid-properties"
          }
        ]
      },
      {
        moduleTitle: "SQL commands",
        topics: [
          {
            title: "Types of SQL Commands",
            videoLink: "https://dummyvideo.com/sql-commands"
          }
        ]
      },
      {
        moduleTitle: "Joins",
        topics: [
          {
            title: "INNER, LEFT< RIGHT , FULL ",
            videoLink: "https://dummyvideo.com/ddl-examples"
          },
          // {
          //   title: "DML Commands with Examples",
          //   videoLink: "https://dummyvideo.com/dml-examples"
          // },
          {
            title: "Self Joins",
            videoLink: "https://dummyvideo.com/db-creation"
          }
        ]
      },
      {
        moduleTitle: "Clauses in DQL commands",
        topics: [
          {
            title: "WHERE, GROUP BY, ORDER BY",
            videoLink: "https://dummyvideo.com/dql-clauses"
          }
        ]
      },
      {
        moduleTitle: "Working with D&T",
        topics: [
          {
            title: "Working with Date,Time and String functions",
            videoLink: "https://dummyvideo.com/dql-clauses"
          }
        ]
      },
      {
        moduleTitle: "Practice",
        topics: [
          {
            title: "Writing optimized queries",
            videoLink: "https://dummyvideo.com/primary-key"
          },
          {
            title: "Live assignments with sample business datasets",
            videoLink: "https://dummyvideo.com/foreign-key"
          },
          {
            title: "Mini-project: Sales Database Analysis",
            videoLink: "https://dummyvideo.com/check-constraint"
          }
        ]
      }
    ]
  },
basicStatistics: {
  
  name: "Basic Statistics - Data Mining",
  modules: [
    {
      moduleTitle: "Project Management Methodology",
      topics: [
        { title: "Stages of Analytics", videoLink: "https://www.youtube.com/watch?v=Video1" },
        { title: "CRISP ML(Q)", videoLink: "https://www.youtube.com/watch?v=Video2" },
        { title: "CRISP DM and other project methodologies", videoLink: "https://www.youtube.com/watch?v=Video3" },
        { title: "Phases of CRISP-ML(Q)", videoLink: "https://www.youtube.com/watch?v=Video4" }
      ]
    },
    {
      moduleTitle: "Phase1a: Business Understanding",
      topics: [
        { title: "Project Scope understanding", videoLink: "https://www.youtube.com/watch?v=Video5" },
        { title: "Objective(s)", videoLink: "https://www.youtube.com/watch?v=Video6" },
        { title: "Constraints", videoLink: "https://www.youtube.com/watch?v=Video7" },
        { title: "Data Optimization terminologies", videoLink: "https://www.youtube.com/watch?v=Video8" },
        { title: "Success Criteria", videoLink: "https://www.youtube.com/watch?v=Video9" },
        { title: "Project Charter", videoLink: "https://www.youtube.com/watch?v=Video10" }
      ]
    },
    {
      moduleTitle: "Phase1b: Data Understanding",
      "topics": [
        { "title": "Regular Data or Big Data", "videoLink": "https://www.youtube.com/watch?v=Video11" },
        { "title": "Structured vs Semi Structured vs Unstructured", "videoLink": "https://www.youtube.com/watch?v=Video12" },
        { "title": "Balanced vs Imbalanced", "videoLink": "https://www.youtube.com/watch?v=Video13" },
        { "title": "Cross-sectional vs Time Series vs Panel Data", "videoLink": "https://www.youtube.com/watch?v=Video14" },
        { "title": "Batch Mode vs Online Mode", "videoLink": "https://www.youtube.com/watch?v=Video15" }
      ]
    },
    {
      "moduleTitle": "Data Collection Strategies",
      "topics": [
        { "title": "Primary Data Sources", "videoLink": "https://www.youtube.com/watch?v=Video16" },
        { "title": "Secondary Data Sources", "videoLink": "https://www.youtube.com/watch?v=Video17" },
        { "title": "Errors while Data", "videoLink": "https://www.youtube.com/watch?v=Video18" },
        { "title": "Data Definition", "videoLink": "https://www.youtube.com/watch?v=Video19" },
        { "title": "Data Versioning", "videoLink": "https://www.youtube.com/watch?v=Video20" },
        { "title": "Feature Engineering", "videoLink": "https://www.youtube.com/watch?v=Video21" }
      ]
    },
    {
      "moduleTitle": "Exploratory Data Analysis (EDA)",
      "topics": [
        { "title": "Data Types", "videoLink": "https://www.youtube.com/watch?v=Video22" },
        { "title": "Measurement Levels", "videoLink": "https://www.youtube.com/watch?v=Video23" },
        { "title": "Univariate Analysis", "videoLink": "https://www.youtube.com/watch?v=Video24" },
        { "title": "Probability and Probability Distribution", "videoLink": "https://www.youtube.com/watch?v=Video25" },
        { "title": "Inferential Statistics", "videoLink": "https://www.youtube.com/watch?v=Video26" },
        { "title": "Sampling Techniques", "videoLink": "https://www.youtube.com/watch?v=Video27" },
        { "title": "1st Moment Business Decision", "videoLink": "https://www.youtube.com/watch?v=Video28" },
        { "title": "2nd Moment Business Decision", "videoLink": "https://www.youtube.com/watch?v=Video29" },
        { "title": "3rd Moment Business Decision", "videoLink": "https://www.youtube.com/watch?v=Video30" },
        { "title": "4th Moment Business Decision", "videoLink": "https://www.youtube.com/watch?v=Video31" },
        { "title": "Graphical Representations", "videoLink": "https://www.youtube.com/watch?v=Video32" },
        { "title": "Bar plot", "videoLink": "https://www.youtube.com/watch?v=Video33" },
        { "title": "Histogram", "videoLink": "https://www.youtube.com/watch?v=Video34" },
        { "title": "Box Plot", "videoLink": "https://www.youtube.com/watch?v=Video35" },
        { "title": "AutoEDA", "videoLink": "https://www.youtube.com/watch?v=Video36" },
        { "title": "Normal Distribution", "videoLink": "https://www.youtube.com/watch?v=Video37" },
        { "title": "Python APIs to Import/Export Data into Database", "videoLink": "https://www.youtube.com/watch?v=Video38" }
      ]
    },
    {
      "moduleTitle": "Phase2: Data Preprocessing",
      "topics": [
        { "title": "Typecasting", "videoLink": "https://www.youtube.com/watch?v=Video39" },
        { "title": "Duplicates", "videoLink": "https://www.youtube.com/watch?v=Video40" },
        { "title": "Outlier Analysis/Treatment", "videoLink": "https://www.youtube.com/watch?v=Video41" },
        { "title": "Missing Values", "videoLink": "https://www.youtube.com/watch?v=Video42" },
        { "title": "Encoding - Dummy Variables", "videoLink": "https://www.youtube.com/watch?v=Video43" },
        { "title": "Transformations", "videoLink": "https://www.youtube.com/watch?v=Video44" },
        { "title": "Scaling - Standardization/Normalization", "videoLink": "https://www.youtube.com/watch?v=Video45" }
      ]
    },
    {
      "moduleTitle": "Inferential Statistics",
      "topics": [
        { "title": "Mathematical Foundations", "videoLink": "https://www.youtube.com/watch?v=Video46" },
        { "title": "Normal Distribution", "videoLink": "https://www.youtube.com/watch?v=Video47" },
        { "title": "Sampling Variation", "videoLink": "https://www.youtube.com/watch?v=Video48" },
        { "title": "Central Limit Theorem", "videoLink": "https://www.youtube.com/watch?v=Video49" },
        { "title": "Confidence Interval", "videoLink": "https://www.youtube.com/watch?v=Video50" },
        { "title": "Z-Distribution and T-Distribution", "videoLink": "https://www.youtube.com/watch?v=Video51" },
        { "title": "Hypothesis Testing", "videoLink": "https://www.youtube.com/watch?v=Video52" }
      ]
    }
  ]
}, 

"Statistics & Data Cleaning": {
  
  name: "Statistics And Data Cleaning",
  modules: [
    {
      moduleTitle: "Statistics",
      topics: [
        { title: "•	Descriptive Statistics (Mean, Median, SD, Range)", videoLink: "https://www.youtube.com/watch?v=Video1" },
        { title: "•	Data Distribution, Skewness, Kurtosis", videoLink: "https://www.youtube.com/watch?v=Video2" },
        { title: "•	Correlation, Covariance, Outliers", videoLink: "https://www.youtube.com/watch?v=Video3" },
        // { title: "Phases of CRISP-ML(Q)", videoLink: "https://www.youtube.com/watch?v=Video4" }
      ]
    },
    {
      moduleTitle: "Data Cleaning & Transformation",
      topics: [
        { title: "Handling Missing Values", videoLink: "https://www.youtube.com/watch?v=Video5" },
        { title: "Removing Duplicates, Standardizing Text", videoLink: "https://www.youtube.com/watch?v=Video6" },
        { title: "Feature Encoding (Label, One-Hot)", videoLink: "https://www.youtube.com/watch?v=Video7" },
        { title: "Real-world cleaning using pandas", videoLink: "https://www.youtube.com/watch?v=Video8" },
        // { title: "Success Criteria", videoLink: "https://www.youtube.com/watch?v=Video9" },
        // { title: "Project Charter", videoLink: "https://www.youtube.com/watch?v=Video10" }
      ]
    },
    // {
    //   moduleTitle: "Phase1b: Data Understanding",
    //   "topics": [
    //     { "title": "Regular Data or Big Data", "videoLink": "https://www.youtube.com/watch?v=Video11" },
    //     { "title": "Structured vs Semi Structured vs Unstructured", "videoLink": "https://www.youtube.com/watch?v=Video12" },
    //     { "title": "Balanced vs Imbalanced", "videoLink": "https://www.youtube.com/watch?v=Video13" },
    //     { "title": "Cross-sectional vs Time Series vs Panel Data", "videoLink": "https://www.youtube.com/watch?v=Video14" },
    //     { "title": "Batch Mode vs Online Mode", "videoLink": "https://www.youtube.com/watch?v=Video15" }
    //   ]
    // },
    // {
    //   moduleTitle: "Data Collection Strategies",
    //   "topics": [
    //     { "title": "Primary Data Sources", "videoLink": "https://www.youtube.com/watch?v=Video16" },
    //     { "title": "Secondary Data Sources", "videoLink": "https://www.youtube.com/watch?v=Video17" },
    //     { "title": "Errors while Data", "videoLink": "https://www.youtube.com/watch?v=Video18" },
    //     { "title": "Data Definition", "videoLink": "https://www.youtube.com/watch?v=Video19" },
    //     { "title": "Data Versioning", "videoLink": "https://www.youtube.com/watch?v=Video20" },
    //     { "title": "Feature Engineering", "videoLink": "https://www.youtube.com/watch?v=Video21" }
    //   ]
    // },
  ]},
  "Tableau for Data Visualization": {
  
    name: "Tableau For DataViz",
    modules: [
      {
        moduleTitle: "Basics:",
        topics: [
          { title: "Tableau Interface, Data Connections", videoLink: "https://www.youtube.com/watch?v=Video1" },
          { title: "Dimensions vs Measures, Filters, Sorting, Grouping", videoLink: "https://www.youtube.com/watch?v=Video2" },
          { title: "Standard Charts: Bar, Line, Pie, Heatmaps, Geomaps", videoLink: "https://www.youtube.com/watch?v=Video3" },
          // { title: "Phases of CRISP-ML(Q)", videoLink: "https://www.youtube.com/watch?v=Video4" }
        ]
      },
      {
        moduleTitle: "Intermediate to Advanced",
        topics: [
          { title: "Calculated Fields, Table Calculations", videoLink: "https://www.youtube.com/watch?v=Video5" },
          { title: "Parameters, Sets, Bins", videoLink: "https://www.youtube.com/watch?v=Video6" },
          { title: "Dual Axis, Combined Charts", videoLink: "https://www.youtube.com/watch?v=Video7" },
          { title: "Actions, Filters, and Dynamic Dashboards", videoLink: "https://www.youtube.com/watch?v=Video8" },
          { title: "Publishing Dashboards & Tableau Public", videoLink: "https://www.youtube.com/watch?v=Video9" },
          { title: "Mini-project: Regional Sales Dashboard", videoLink: "https://www.youtube.com/watch?v=Video10" }
        ]
      },
      // {
      //   moduleTitle: "Phase1b: Data Understanding",
      //   "topics": [
      //     { "title": "Regular Data or Big Data", "videoLink": "https://www.youtube.com/watch?v=Video11" },
      //     { "title": "Structured vs Semi Structured vs Unstructured", "videoLink": "https://www.youtube.com/watch?v=Video12" },
      //     { "title": "Balanced vs Imbalanced", "videoLink": "https://www.youtube.com/watch?v=Video13" },
      //     { "title": "Cross-sectional vs Time Series vs Panel Data", "videoLink": "https://www.youtube.com/watch?v=Video14" },
      //     { "title": "Batch Mode vs Online Mode", "videoLink": "https://www.youtube.com/watch?v=Video15" }
      //   ]
      // },
      // {
      //   moduleTitle: "Data Collection Strategies",
      //   "topics": [
      //     { "title": "Primary Data Sources", "videoLink": "https://www.youtube.com/watch?v=Video16" },
      //     { "title": "Secondary Data Sources", "videoLink": "https://www.youtube.com/watch?v=Video17" },
      //     { "title": "Errors while Data", "videoLink": "https://www.youtube.com/watch?v=Video18" },
      //     { "title": "Data Definition", "videoLink": "https://www.youtube.com/watch?v=Video19" },
      //     { "title": "Data Versioning", "videoLink": "https://www.youtube.com/watch?v=Video20" },
      //     { "title": "Feature Engineering", "videoLink": "https://www.youtube.com/watch?v=Video21" }
      //   ]
      // },
    ]},

    // This is for foundatoiions of Data analytics and excle..
  "Foundations of Data Analytics + Excel ": {
  
    name: "Data Analytics Excel",
    modules: [
      {
        moduleTitle: "Theory",
        topics: [
          { title: "What is Data Analytics? Scope, Lifecycle & Applications", videoLink: "https://www.youtube.com/watch?v=Video1" },
          { title: "Roles in Analytics, Industry Use Cases", videoLink: "https://www.youtube.com/watch?v=Video2" },
          { title: "Data Types, Formats, Structures (Structured vs Unstructured)", videoLink: "https://www.youtube.com/watch?v=Video3" },
          // { title: "Phases of CRISP-ML(Q)", videoLink: "https://www.youtube.com/watch?v=Video4" }
        ]
      },
      {
        moduleTitle: "Excel Hands-on",
        topics: [
          { title: "Data Entry, Formatting, Data Cleaning Techniques", videoLink: "https://www.youtube.com/watch?v=Video5" },
          { title: "Formulas: Logical (IF, AND), Lookup (VLOOKUP, INDEX-MATCH)", videoLink: "https://www.youtube.com/watch?v=Video6" },
          { title: "Pivot Tables, Charts & Basic Dashboards", videoLink: "https://www.youtube.com/watch?v=Video7" },
          { title: "Excel Tips for Analysts: Named Ranges, Conditional Formatting", videoLink: "https://www.youtube.com/watch?v=Video8" },
          // { title: "Mini-project: Financial KPI Dashboard", videoLink: "https://www.youtube.com/watch?v=Video9" },
          // { title: "Project Charter", videoLink: "https://www.youtube.com/watch?v=Video10" }
        ]
      },
      // {
      //   moduleTitle: "Phase1b: Data Understanding",
      //   "topics": [
      //     { "title": "Regular Data or Big Data", "videoLink": "https://www.youtube.com/watch?v=Video11" },
      //     { "title": "Structured vs Semi Structured vs Unstructured", "videoLink": "https://www.youtube.com/watch?v=Video12" },
      //     { "title": "Balanced vs Imbalanced", "videoLink": "https://www.youtube.com/watch?v=Video13" },
      //     { "title": "Cross-sectional vs Time Series vs Panel Data", "videoLink": "https://www.youtube.com/watch?v=Video14" },
      //     { "title": "Batch Mode vs Online Mode", "videoLink": "https://www.youtube.com/watch?v=Video15" }
      //   ]
      // },
      // {
      //   moduleTitle: "Data Collection Strategies",
      //   "topics": [
      //     { "title": "Primary Data Sources", "videoLink": "https://www.youtube.com/watch?v=Video16" },
      //     { "title": "Secondary Data Sources", "videoLink": "https://www.youtube.com/watch?v=Video17" },
      //     { "title": "Errors while Data", "videoLink": "https://www.youtube.com/watch?v=Video18" },
      //     { "title": "Data Definition", "videoLink": "https://www.youtube.com/watch?v=Video19" },
      //     { "title": "Data Versioning", "videoLink": "https://www.youtube.com/watch?v=Video20" },
      //     { "title": "Feature Engineering", "videoLink": "https://www.youtube.com/watch?v=Video21" }
      //   ]
      // },
    ]},

  // This is for power Bi 
  "Power BI for Business Reporting": {
  
  name: "PowerBI For Business",
  modules: [
    {
      moduleTitle: "Fundamentals",
      topics: [
        { title: "Power BI Interface, Data Importing", videoLink: "https://www.youtube.com/watch?v=Video1" },
        { title: "Data Transformation using Power Query", videoLink: "https://www.youtube.com/watch?v=Video2" },
        { title: "Data Modeling and Relationships", videoLink: "https://www.youtube.com/watch?v=Video3" },
        // { title: "Phases of CRISP-ML(Q)", videoLink: "https://www.youtube.com/watch?v=Video4" }
      ]
    },
    {
      moduleTitle: "Advanced",
      topics: [
        { title: "DAX Formulas (SUMX, CALCULATE, IF, SWITCH)", videoLink: "https://www.youtube.com/watch?v=Video5" },
        { title: "Time Intelligence Functions", videoLink: "https://www.youtube.com/watch?v=Video6" },
        { title: "Designing Interactive Reports, Bookmarks", videoLink: "https://www.youtube.com/watch?v=Video7" },
        { title: "Using Power BI Service: Sharing and Scheduling", videoLink: "https://www.youtube.com/watch?v=Video8" },
        { title: "Mini-project: Financial KPI Dashboard", videoLink: "https://www.youtube.com/watch?v=Video9" },
        // { title: "Project Charter", videoLink: "https://www.youtube.com/watch?v=Video10" }
      ]
    },
    // {
    //   moduleTitle: "Phase1b: Data Understanding",
    //   "topics": [
    //     { "title": "Regular Data or Big Data", "videoLink": "https://www.youtube.com/watch?v=Video11" },
    //     { "title": "Structured vs Semi Structured vs Unstructured", "videoLink": "https://www.youtube.com/watch?v=Video12" },
    //     { "title": "Balanced vs Imbalanced", "videoLink": "https://www.youtube.com/watch?v=Video13" },
    //     { "title": "Cross-sectional vs Time Series vs Panel Data", "videoLink": "https://www.youtube.com/watch?v=Video14" },
    //     { "title": "Batch Mode vs Online Mode", "videoLink": "https://www.youtube.com/watch?v=Video15" }
    //   ]
    // },
    // {
    //   moduleTitle: "Data Collection Strategies",
    //   "topics": [
    //     { "title": "Primary Data Sources", "videoLink": "https://www.youtube.com/watch?v=Video16" },
    //     { "title": "Secondary Data Sources", "videoLink": "https://www.youtube.com/watch?v=Video17" },
    //     { "title": "Errors while Data", "videoLink": "https://www.youtube.com/watch?v=Video18" },
    //     { "title": "Data Definition", "videoLink": "https://www.youtube.com/watch?v=Video19" },
    //     { "title": "Data Versioning", "videoLink": "https://www.youtube.com/watch?v=Video20" },
    //     { "title": "Feature Engineering", "videoLink": "https://www.youtube.com/watch?v=Video21" }
    //   ]
    // },
  ]},

  "Machine Learning": {
    name: "Machine Learning",
    modules: [
      {
        moduleTitle: "Data Mining Supervised vs Unsupervised Learning",
        topics: [
          {
            title: "Data Mining Supervised vs Unsupervised Learning",
            videoLink: "https://dummyvideo.com/data-mining-supervised-vs-unsupervised",
            subtopics: []
          }
        ]
      },
      {
        moduleTitle: "Data Mining Unsupervised Learning",
        topics: [
          {
            title: "Clustering",
            videoLink: "https://dummyvideo.com/clustering",
            subtopics: [
              {
                title: "Hierarchial Clustering",
                videoLink: "https://dummyvideo.com/hierarchical-clustering"
              },
              {
                title: "Non-Hierarchial Clustering - Kmeans",
                videoLink: "https://dummyvideo.com/kmeans"
              },
              {
                title: "DBSCAN",
                videoLink: "https://dummyvideo.com/dbscan"
              }
            ]
          },
          {
            title: "Dimension Reduction",
            videoLink: "https://dummyvideo.com/dimension-reduction",
            subtopics: [
              {
                title: "PCA",
                videoLink: "https://dummyvideo.com/pca"
              }
            ]
          },
          {
            title: "Association Rules",
            videoLink: "https://dummyvideo.com/association-rules",
            subtopics: []
          }
        ]
      },
      {
        moduleTitle: "Text Mining",
        topics: [
          {
            title: "String Manipulation with re() package",
            videoLink: "https://dummyvideo.com/string-manipulation",
            subtopics: []
          },
          {
            title: "Tokenization",
            videoLink: "https://dummyvideo.com/tokenization",
            subtopics: []
          },
          {
            title: "Bag of Words",
            videoLink: "https://dummyvideo.com/bag-of-words",
            subtopics: []
          },
          {
            title: "DTM/TDM",
            videoLink: "https://dummyvideo.com/dtm-tdm",
            subtopics: []
          },
          {
            title: "Word Cloud",
            videoLink: "https://dummyvideo.com/word-cloud",
            subtopics: []
          },
          {
            title: "Sentiment Analysis",
            videoLink: "https://dummyvideo.com/sentiment-analysis",
            subtopics: []
          }
        ]
      },
      {
        moduleTitle: "Data Mining Supervised Learning",
        topics: [
          {
            title: "Data Mining Supervised Learning",
            videoLink: "https://dummyvideo.com/data-mining-supervised-learning",
            subtopics: []
          }
        ]
      },
      {
        moduleTitle: "Machine Learning Primer",
        topics: [
          {
            title: "Model Selection",
            videoLink: "https://dummyvideo.com/model-selection",
            subtopics: []
          },
          {
            title: "Data Split for Validation",
            videoLink: "https://dummyvideo.com/data-split",
            subtopics: []
          },
          {
            title: "Model Evaluation",
            videoLink: "https://dummyvideo.com/model-evaluation",
            subtopics: []
          },
          {
            title: "Evaluation Techniques",
            videoLink: "https://dummyvideo.com/evaluation-techniques",
            subtopics: []
          },
          {
            title: "Model Tuning",
            videoLink: "https://dummyvideo.com/model-tuning",
            subtopics: []
          },
          {
            title: "Hyperparameter Optimization",
            videoLink: "https://dummyvideo.com/hyperparameter-optimization",
            subtopics: []
          }
        ]
      },
      {
        moduleTitle: "Regression Techniques",
        topics: [
          {
            title: "Scatter plot and Correlation Coefficient",
            videoLink: "https://dummyvideo.com/scatter-correlation",
            subtopics: []
          },
          {
            title: "Linear Regression",
            videoLink: "https://dummyvideo.com/linear-regression",
            subtopics: []
          },
          {
            title: "Logistic Regression",
            videoLink: "https://dummyvideo.com/logistic-regression",
            subtopics: []
          }
        ]
      },
      {
        moduleTitle: "Classification Techniques",
        topics: [
          {
            title: "Naïve Bayes",
            videoLink: "https://dummyvideo.com/naive-bayes",
            subtopics: []
          },
          {
            title: "KNN",
            videoLink: "https://dummyvideo.com/knn",
            subtopics: []
          },
          {
            title: "Decision Trees",
            videoLink: "https://dummyvideo.com/decision-trees",
            subtopics: []
          },
          {
            title: "Ensemble Techniques",
            videoLink: "https://dummyvideo.com/ensemble-techniques",
            subtopics: [
              {
                title: "Voting",
                videoLink: "https://dummyvideo.com/voting"
              },
              {
                title: "Stacking",
                videoLink: "https://dummyvideo.com/stacking"
              },
              {
                title: "Bagging",
                videoLink: "https://dummyvideo.com/bagging"
              },
              {
                title: "Random Forest",
                videoLink: "https://dummyvideo.com/random-forest"
              },
              {
                title: "Boosting",
                videoLink: "https://dummyvideo.com/boosting"
              }
            ]
          }
        ]
      },
      {
        moduleTitle: "Neural Networks",
        topics: [
          {
            title: "Neuron",
            videoLink: "https://dummyvideo.com/neuron",
            subtopics: []
          },
          {
            title: "Perceptron Algorithm",
            videoLink: "https://dummyvideo.com/perceptron",
            subtopics: []
          },
          {
            title: "Weight Calculation",
            videoLink: "https://dummyvideo.com/weight-calculation",
            subtopics: []
          },
          {
            title: "MLPA / ANN",
            videoLink: "https://dummyvideo.com/mlpa-ann",
            subtopics: []
          }
        ]
      },
      {
        moduleTitle: "Time Series Analysis",
        topics: [
          {
            title: "Components of Time Series",
            videoLink: "https://dummyvideo.com/time-series-components",
            subtopics: []
          },
          {
            title: "EDA on Time Series",
            videoLink: "https://dummyvideo.com/time-series-eda",
            subtopics: []
          },
          {
            title: "Strategies for Time Series Partition",
            videoLink: "https://dummyvideo.com/time-series-partition",
            subtopics: []
          },
          {
            title: "Models for Forecasting",
            videoLink: "https://dummyvideo.com/time-series-forecasting",
            subtopics: []
          },
          {
            title: "Model Evaluation",
            videoLink: "https://dummyvideo.com/time-series-evaluation",
            subtopics: []
          }
        ]
      }
    ]
  },

  "Deep Learning": {
    name: "Deep Learning",
    modules: [
    {
      moduleTitle: "Deep Learning Primer",
      topics: [
        { title: "Neural Network", videoLink: "https://example.com/deep-learning/module1/topic1" },
        { title: "Neurons", videoLink: "https://example.com/deep-learning/module1/topic2" },
        { title: "Perceptron", videoLink: "https://example.com/deep-learning/module1/topic3" },
        { title: "Neuron Weights", videoLink: "https://example.com/deep-learning/module1/topic4" },
        { title: "Activation Functions", videoLink: "https://example.com/deep-learning/module1/topic5" },
        { title: "Networks of Neurons", videoLink: "https://example.com/deep-learning/module1/topic6" },
        { title: "Input or Visible Layers", videoLink: "https://example.com/deep-learning/module1/topic7" },
        { title: "Hidden Units", videoLink: "https://example.com/deep-learning/module1/topic8" },
        { title: "Output Layer", videoLink: "https://example.com/deep-learning/module1/topic9" },
        { title: "Architecture Design", videoLink: "https://example.com/deep-learning/module1/topic10" },
        { title: "Gradient-Based Learning", videoLink: "https://example.com/deep-learning/module1/topic11" },
        { title: "Performance of Deep Learning Models", videoLink: "https://example.com/deep-learning/module1/topic12" }
      ]
    },
    {
      moduleTitle: "Computer Vision",
      topics: [
        { title: "Image Filtering", videoLink: "https://example.com/deep-learning/module2/topic1" },
        { title: "Pixel Operations", videoLink: "https://example.com/deep-learning/module2/topic2" },
        { title: "Edge Detecting", videoLink: "https://example.com/deep-learning/module2/topic3" },
        { title: "Image sub-sampling", videoLink: "https://example.com/deep-learning/module2/topic4" },
        { title: "Image Features Detection", videoLink: "https://example.com/deep-learning/module2/topic5" },
        { title: "Image Feature Descriptors", videoLink: "https://example.com/deep-learning/module2/topic6" },
        { title: "Feature Matching", videoLink: "https://example.com/deep-learning/module2/topic7" }
      ]
    },
    {
      moduleTitle: "Convolution Neural Network",
      topics: [
        { title: "Image Processing models: Convolutional Networks", videoLink: "https://example.com/deep-learning/module3/topic1" },
        { title: "Convolutional Layers", videoLink: "https://example.com/deep-learning/module3/topic2" },
        { title: "Filters", videoLink: "https://example.com/deep-learning/module3/topic3" },
        { title: "Feature Maps", videoLink: "https://example.com/deep-learning/module3/topic4" },
        { title: "Pooling Layers", videoLink: "https://example.com/deep-learning/module3/topic5" },
        { title: "Down sampling", videoLink: "https://example.com/deep-learning/module3/topic6" },
        { title: "Fully Connected Layers", videoLink: "https://example.com/deep-learning/module3/topic7" }
      ]
    },
    {
      moduleTitle: "Recurrent Neural Network",
      topics: [
        { title: "Sequence Modeling: Recurrent and recursive networks", videoLink: "https://example.com/deep-learning/module4/topic1" },
        { title: "Recurrent Neural Networks", videoLink: "https://example.com/deep-learning/module4/topic2" },
        { title: "Time Series Prediction with Multilayer Perceptron", videoLink: "https://example.com/deep-learning/module4/topic3" },
        { title: "RNN -Vanishing & Exploding Gradient", videoLink: "https://example.com/deep-learning/module4/topic4" },
        { title: "Time Series Prediction with LSTM", videoLink: "https://example.com/deep-learning/module4/topic5" },
        { title: "Gated Recurrent Unit (GRU)", videoLink: "https://example.com/deep-learning/module4/topic6" }
      ]
    },
    {
      moduleTitle: "Advance Networks",
      topics: [
        { title: "Word Embeddings in NLP", videoLink: "https://example.com/deep-learning/module5/topic1" },
        { title: "Sequence to Sequence models", videoLink: "https://example.com/deep-learning/module5/topic2" },
        { title: "Encoder & Decoder Architecture", videoLink: "https://example.com/deep-learning/module5/topic3" },
        { title: "Attention Mechanism", videoLink: "https://example.com/deep-learning/module5/topic4" },
        { title: "Transformers, Self Attention", videoLink: "https://example.com/deep-learning/module5/topic5" },
        { title: "BERT, GPT", videoLink: "https://example.com/deep-learning/module5/topic6" },
        { title: "Large Language Models", videoLink: "https://example.com/deep-learning/module5/topic7" },
        { title: "Prompt Engineering", videoLink: "https://example.com/deep-learning/module5/topic8" },
        { title: "Hands-On BERT, & LLM with gemini-2.0-flash", videoLink: "https://example.com/deep-learning/module5/topic9" },
        { title: "Deep Belief Networks (DBN)", videoLink: "https://example.com/deep-learning/module5/topic10" },
        { title: "Generative Adversal Networks (GANs)", videoLink: "https://example.com/deep-learning/module5/topic11" },
        { title: "Reinforcement Learning and Q-Learning", videoLink: "https://example.com/deep-learning/module5/topic12" }
      ]
    }
  ]
  },
  "Capstone Project": {
    name: "Capstone Project",
    modules: [
    {
      moduleTitle: "Deep Learning Primer",
      topics: [
        { title: "Neural Network", videoLink: "https://example.com/deep-learning/module1/topic1" },
        { title: "Neurons", videoLink: "https://example.com/deep-learning/module1/topic2" },
        { title: "Perceptron", videoLink: "https://example.com/deep-learning/module1/topic3" },
        { title: "Neuron Weights", videoLink: "https://example.com/deep-learning/module1/topic4" },
        { title: "Activation Functions", videoLink: "https://example.com/deep-learning/module1/topic5" },
        { title: "Networks of Neurons", videoLink: "https://example.com/deep-learning/module1/topic6" },
        { title: "Input or Visible Layers", videoLink: "https://example.com/deep-learning/module1/topic7" },
        { title: "Hidden Units", videoLink: "https://example.com/deep-learning/module1/topic8" },
        { title: "Output Layer", videoLink: "https://example.com/deep-learning/module1/topic9" },
        { title: "Architecture Design", videoLink: "https://example.com/deep-learning/module1/topic10" },
        { title: "Gradient-Based Learning", videoLink: "https://example.com/deep-learning/module1/topic11" },
        { title: "Performance of Deep Learning Models", videoLink: "https://example.com/deep-learning/module1/topic12" }
      ]
    },
    {
      moduleTitle: "Computer Vision",
      topics: [
        { title: "Image Filtering", videoLink: "https://example.com/deep-learning/module2/topic1" },
        { title: "Pixel Operations", videoLink: "https://example.com/deep-learning/module2/topic2" },
        { title: "Edge Detecting", videoLink: "https://example.com/deep-learning/module2/topic3" },
        { title: "Image sub-sampling", videoLink: "https://example.com/deep-learning/module2/topic4" },
        { title: "Image Features Detection", videoLink: "https://example.com/deep-learning/module2/topic5" },
        { title: "Image Feature Descriptors", videoLink: "https://example.com/deep-learning/module2/topic6" },
        { title: "Feature Matching", videoLink: "https://example.com/deep-learning/module2/topic7" }
      ]
    },
    {
      moduleTitle: "Convolution Neural Network",
      topics: [
        { title: "Image Processing models: Convolutional Networks", videoLink: "https://example.com/deep-learning/module3/topic1" },
        { title: "Convolutional Layers", videoLink: "https://example.com/deep-learning/module3/topic2" },
        { title: "Filters", videoLink: "https://example.com/deep-learning/module3/topic3" },
        { title: "Feature Maps", videoLink: "https://example.com/deep-learning/module3/topic4" },
        { title: "Pooling Layers", videoLink: "https://example.com/deep-learning/module3/topic5" },
        { title: "Down sampling", videoLink: "https://example.com/deep-learning/module3/topic6" },
        { title: "Fully Connected Layers", videoLink: "https://example.com/deep-learning/module3/topic7" }
      ]
    },
    {
      moduleTitle: "Recurrent Neural Network",
      topics: [
        { title: "Sequence Modeling: Recurrent and recursive networks", videoLink: "https://example.com/deep-learning/module4/topic1" },
        { title: "Recurrent Neural Networks", videoLink: "https://example.com/deep-learning/module4/topic2" },
        { title: "Time Series Prediction with Multilayer Perceptron", videoLink: "https://example.com/deep-learning/module4/topic3" },
        { title: "RNN -Vanishing & Exploding Gradient", videoLink: "https://example.com/deep-learning/module4/topic4" },
        { title: "Time Series Prediction with LSTM", videoLink: "https://example.com/deep-learning/module4/topic5" },
        { title: "Gated Recurrent Unit (GRU)", videoLink: "https://example.com/deep-learning/module4/topic6" }
      ]
    },
    {
      moduleTitle: "Advance Networks",
      topics: [
        { title: "Word Embeddings in NLP", videoLink: "https://example.com/deep-learning/module5/topic1" },
        { title: "Sequence to Sequence models", videoLink: "https://example.com/deep-learning/module5/topic2" },
        { title: "Encoder & Decoder Architecture", videoLink: "https://example.com/deep-learning/module5/topic3" },
        { title: "Attention Mechanism", videoLink: "https://example.com/deep-learning/module5/topic4" },
        { title: "Transformers, Self Attention", videoLink: "https://example.com/deep-learning/module5/topic5" },
        { title: "BERT, GPT", videoLink: "https://example.com/deep-learning/module5/topic6" },
        { title: "Large Language Models", videoLink: "https://example.com/deep-learning/module5/topic7" },
        { title: "Prompt Engineering", videoLink: "https://example.com/deep-learning/module5/topic8" },
        { title: "Hands-On BERT, & LLM with gemini-2.0-flash", videoLink: "https://example.com/deep-learning/module5/topic9" },
        { title: "Deep Belief Networks (DBN)", videoLink: "https://example.com/deep-learning/module5/topic10" },
        { title: "Generative Adversal Networks (GANs)", videoLink: "https://example.com/deep-learning/module5/topic11" },
        { title: "Reinforcement Learning and Q-Learning", videoLink: "https://example.com/deep-learning/module5/topic12" }
      ]
    }
  ]
  },
  
};


  






